import { MockDataService } from 'src/app/shared/providers/mock-data.service';
import { WebNavService } from './../webnavigation.service';
import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  AiCollectionInitAssetRequestDto,
  CardsService,
} from 'src/app/shared/providers/cards.service';
import { SettingsService } from 'src/app/shared/providers/settings.service';
import { UploadFileService } from 'src/app/shared/providers/upload-file.service';
import { UserDataService } from 'src/app/shared/providers/user-data.service';
import { UtilityFunctionsService } from 'src/app/shared/providers/utility-functions.service';
import { ReviewCollectionsService } from 'src/app/shared/providers/review-collections.service';
import { ICardCollection } from 'src/app/models/collection';
import { FOOTER_MODE } from 'src/app/models/menu';
import { environment } from 'src/environments/environment';
import { CARD_PURCHASE_STATUS, CARD_TYPE, CARDS_MODE, CARD_CONTROL_BTN, ICard, ICardAction, ICardFeedModificator, INavpanelAction, LIBARY_MODE, ModelCardRendered, NAVPANEL_ACTION_TYPE, SUBSCRIPTION_STATUS, SWITCH_PANEL_ITEM } from 'src/app/models/card';
import { modelFeedAnimation, inOutAnimation, inOutAnimationFast } from 'src/app/shared/providers/animations-list';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MAT_MENU_DEFAULT_OPTIONS, MatMenuTrigger } from '@angular/material/menu';
import { DialogData, ConfirmationDialogComponent } from 'src/app/shared/components/dialog/confirmation-dialog.component';
import { POPUP_TEXT } from 'src/app/shared/text/popup-texts';
import { Observable, Subscription, catchError, finalize, from, merge, of, tap, timer } from 'rxjs';
import { concatMap, map, mergeMap, retry, take } from 'rxjs/operators';
import { WebModelsCardComponent } from '../web-models-card/web-models-card.component';
import { FirebaseAuthService } from 'src/app/shared/providers/firebase-auth.service';
import { ADVANCED_SEARCH_BASELINE_COUNT, ADVANCED_SEARCH_DEFAULT_GENERATION_MODE, ADVANCED_SEARCH_GENERATION_CONCURRENCY, ADVANCED_SEARCH_MAX_COUNT, ADVANCED_SEARCH_MODE_LABELS, ADVANCED_SEARCH_SHEET_BATCH_DELAY_MS, ADVANCED_SEARCH_SHEET_BATCH_RETRY_COUNT, ADVANCED_SEARCH_SHEET_BATCH_RETRY_DELAY_MS, ADVANCED_SEARCH_SHEET_BATCH_SIZE, AdvancedSearchDraft, AdvancedSearchGenerationMode, AdvancedSearchMode, AdvancedSearchPlannerAsset, AdvancedSearchPlannerResponse, AdvancedSearchPreviewCard, AdvancedSearchUiState, GenerateAdvancedSearchAssetPairBatchResponse, GenerateAdvancedSearchAssetResponse, GenerateAdvancedSearchAssetSheetResponse, getAdvancedSearchGenerationModeLabel, normalizeAdvancedSearchGenerationMode } from 'src/app/models/advanced-search';
import { AdvancedSearchService } from '../advanced-search.service';
import { AiSearchService } from '../ai-search.service';
import { AiSearchResultGroup, SaveCollectionAsset } from 'src/app/models/ai-search';
import { WebUploadService } from '../webupload.service';
import { AuthpopupComponent } from 'src/app/shared/components/authpopup/authpopup.component';
import { WebaccountComponent } from '../webaccount/webaccount.component';
import { WebsubscriptionComponent } from '../websubscription/websubscription.component';
import { StripeService } from 'ngx-stripe';
import { WebpopupdialogComponent, WebDialogData } from '../webpopupdialog/webpopupdialog.component';
import { AdvancedSearchNavbarComponent } from '../advanced-search-navbar/advanced-search-navbar.component';
import {
  WebAdvancedSearchDevComponent,
  WebAdvancedSearchDevPairBatchState
} from '../web-advanced-search-dev/web-advanced-search-dev.component';
import { createAdvancedSearchSessionCollection } from 'src/app/models/advanced-search-session-collection';

interface AdvancedSearchAiCollectionSaveResult {
  collectionId: string;
  shareId?: string;
  savedCount: number;
}

interface AdvancedSearchAiCollectionSaveOptions {
  emptyStateMessage: string;
  noValidAssetsMessage?: string;
  showSkippedAssetsMessage?: boolean;
}

@Component({
  selector: 'app-weblibrary-new-ai-search',
  templateUrl: './weblibrary-new-ai-search.component.html',
  styleUrls: ['./weblibrary-new-ai-search.component.scss'],
  animations: [modelFeedAnimation, inOutAnimation, inOutAnimationFast],
  providers: [
    {
      provide: MAT_MENU_DEFAULT_OPTIONS,
      useValue: {
        overlapTrigger: false,
        yPosition: 'above',
        backdropClass: 'webmenu-backdrop',
        overlayPanelClass: 'webmenu-overlay'
      }
    }
  ]
})
export class WeblibraryNewAiSearchComponent implements OnInit, AfterViewInit, OnDestroy {
  private readonly advancedSearchBaselineCount = ADVANCED_SEARCH_BASELINE_COUNT;
  private readonly advancedSearchMaxCount = ADVANCED_SEARCH_MAX_COUNT;
  private readonly advancedSearchGenerationConcurrency = ADVANCED_SEARCH_GENERATION_CONCURRENCY;
  private readonly advancedSearchSheetBatchSize = ADVANCED_SEARCH_SHEET_BATCH_SIZE;
  private readonly advancedSearchSheetBatchDelayMs = ADVANCED_SEARCH_SHEET_BATCH_DELAY_MS;
  private readonly advancedSearchSheetBatchRetryCount = ADVANCED_SEARCH_SHEET_BATCH_RETRY_COUNT;
  private readonly advancedSearchSheetBatchRetryDelayMs = ADVANCED_SEARCH_SHEET_BATCH_RETRY_DELAY_MS;
  private readonly advancedSearchAutoPairBatchSize = 6;

  // v1 of the composer is a PLAIN backend search (POST /ai-search/search), not the
  // generative plan+generate pipeline. While this is on we map backend results
  // straight into the existing preview cards and hide generative-only affordances
  // (per-card pin/delete/retry, save-to-collection). Flip to false to bring the
  // generative flow back.
  public readonly plainSearchMode = true;
  private readonly plainSearchLimit = 100;

  // Plain-search selection for save-to-collection. Independent of the generative
  // pin set so the two flows never interfere.
  public plainSearchSelectedIds = new Set<string>();

  // Round-trip latency (ms) of the last plain search request, for the HUD readout.
  public plainSearchLatencyMs: number | null = null;

  @ViewChild('modelCardsFeed', { static: false })
  public modelCardsFeedRef: WebModelsCardComponent;

  @ViewChild('libraryAddMenuTrigger', { static: false })
  public libraryAddMenuTrigger?: MatMenuTrigger;

  @ViewChild('libraryAddMenuAnchor', { static: false })
  public libraryAddMenuAnchorRef?: ElementRef<HTMLButtonElement>;

  @ViewChild('advancedSearchNavbar', { static: false })
  public advancedSearchNavbarRef?: AdvancedSearchNavbarComponent;

  private handedOverSearchSub?: Subscription;

  public isModelFeedShown: boolean = false;
  public modelCardsMock: ModelCardRendered[];
  public cardFeedCardStartPosition: number;
  public cardFeedMode: CARDS_MODE = CARDS_MODE.COMPOSITE_FEED;
  public weblibraryMode: LIBARY_MODE = LIBARY_MODE.DEFAULT;
  public currentLibraryFooterMode: FOOTER_MODE;
  public cardToEdit: ICard;
  public webLibraryFeedModificator: ICardFeedModificator;
  public homeCollections: ICardCollection[];
  public inReviewCollection: ICardCollection | null = null;
  public advancedSearchUiState: AdvancedSearchUiState = 'idle';
  public advancedSearchCards: AdvancedSearchPreviewCard[] = [];
  public advancedSearchErrorMessage: string = '';
  public normalizedAdvancedSearchPrompt: string = '';
  public advancedSearchDraftPrompt: string = '';
  public lastSubmittedAdvancedSearchPrompt: string = '';
  public currentAdvancedSearchMode: AdvancedSearchMode = 'scene-kit';
  public readonly aiGeneratedGalleryFeedModificator: ICardFeedModificator = { isAiPreviewFeed: true };
  public advancedSearchAutoPairInProgress: boolean = false;
  public advancedSearchAutoPairStopRequested: boolean = false;
  public advancedSearchAutoPairTotal: number = 0;
  public advancedSearchAutoPairDone: number = 0;
  public advancedSearchAutoPairSuccess: number = 0;
  public advancedSearchAutoPairLastRunStopped: boolean = false;
  public advancedSearchAutoPairFailedCardIds: Set<string> = new Set<string>();
  public advancedSearchCollectionSaveInProgress: boolean = false;

  private readonly inReviewCollectionStatus: string = 'in-review';
  private inReviewCollectionLoading: boolean = false;
  private routeAdvancedSearchGenerationMode: AdvancedSearchGenerationMode | null = null;
  private routeAdvancedSearchGenerationModeRaw: string | null = null;
  private routeAdvancedSearchGenerationModeInvalid: boolean = false;
  private advancedSearchRequestToken: number = 0;
  private advancedSearchPinnedCardIds: Set<string> = new Set<string>();
  private advancedSearchLandscapeLoadingCardIds: Set<string> = new Set<string>();
  private advancedSearchLandscapeSubscriptions: Map<string, Subscription> = new Map<string, Subscription>();
  private advancedSearchLandscapeRequestPromises: Map<string, Promise<{ ok: boolean; cardId: string }>> = new Map<string, Promise<{ ok: boolean; cardId: string }>>();
  private advancedSearchCardOrderMap: Map<string, number> = new Map<string, number>();
  private activeAdvancedSearchRunCardIds: Set<string> = new Set<string>();
  private activePlanningSeedCardIds: Set<string> = new Set<string>();
  private advancedSearchOrderCounter: number = 0;
  private advancedSearchSaveAfterAutoPairRequested: boolean = false;
  private planningSubscription?: Subscription;
  private generationSubscription?: Subscription;
  private accountPopupSubscription?: Subscription;
  private subscriptionPopupSubscription?: Subscription;

  public LIBARY_MODE = LIBARY_MODE;
  public SWITCH_PANEL_ITEM = SWITCH_PANEL_ITEM;
  public FOOTER_MODE = FOOTER_MODE;
  public uploadStatusSub: Subscription;
  public initilizeDataSub: Subscription;
  public userDataUpdatedSub: Subscription;


  constructor(
    public userDataService: UserDataService,
    private readonly route: ActivatedRoute,
    private readonly router: Router,
    public mockDataService: MockDataService,
    public webNavService: WebNavService,
    public settingService: SettingsService,
    public cardService: CardsService,
    public uploadService: UploadFileService,
    private readonly webUploadService: WebUploadService,
    private readonly advancedSearchService: AdvancedSearchService,
    private readonly aiSearchService: AiSearchService,
    public reviewCollectionsService: ReviewCollectionsService,
    public dialog: MatDialog,
    private readonly stripeService: StripeService,
    public cdr: ChangeDetectorRef,
    public firebaseAuth: FirebaseAuthService,
    public utilityService: UtilityFunctionsService,
  ) {
  }

  ngOnInit(): void {
    // const dialogRef = this.dialog.open(MissingTexturesSyncComponent, {data: {}, restoreFocus: false, panelClass: 'webpopup-overlay'},);

    this.webNavService.footerMode = FOOTER_MODE.LIBRARY;

    this.uploadStatusSub = this.uploadService.uploadStatusSubscription.subscribe(()=> {
      this.cdr.detectChanges();
    });

    this.initilizeDataSub = this.userDataService.initilizeUserDataFinished.subscribe(async (isFinished) => {
      this.cdr.detectChanges();
    });

    this.userDataUpdatedSub = this.firebaseAuth.userDataUpdated.subscribe(() => {
      this.loadInReviewCollection();
    });

    this.loadInReviewCollection();

    // TEMPORARY FOR DEBUG !!! DELETE LATER
    // this.webNavService.currentWebSwitchPanelMode = SWITCH_PANEL_ITEM.PUBLISHED;
    // this.webNavService.footerMode = FOOTER_MODE.LIBRARY_PUBLISH_REJECTED_REVIEW;
    // this.weblibraryMode = LIBARY_MODE.PUBLISH_REJECTED_REVIEW;
  }

  public get isAdvancedSearchActive(): boolean {
    return this.advancedSearchUiState !== 'idle' || this.advancedSearchCards.length > 0;
  }

  public get isAdvancedSearchBusy(): boolean {
    return this.advancedSearchUiState === 'planning' || this.advancedSearchUiState === 'generating';
  }

  public get orderedAdvancedSearchCards(): AdvancedSearchPreviewCard[] {
    const cardsWithOrder = this.advancedSearchCards.map((card) => ({
      card,
      order: this.getAdvancedSearchCardOrder(card.id),
      isPinned: this.advancedSearchPinnedCardIds.has(card.id),
    }));

    cardsWithOrder.sort((left, right) => {
      if (left.isPinned !== right.isPinned) {
        return left.isPinned ? -1 : 1;
      }

      return left.order - right.order;
    });

    return cardsWithOrder.map(({ card }) => card);
  }

  public get shouldShowAdvancedSearchResults(): boolean {
    return this.webNavService.isUserAuthenticated
      && this.weblibraryMode === LIBARY_MODE.DEFAULT
      && this.isAdvancedSearchActive;
  }

  public get hasSuccessfulAdvancedSearchCards(): boolean {
    return this.advancedSearchCards.some((card) => card.status === 'success');
  }

  // Plain search shows results only — pin/delete/retry belong to the generative
  // flow (pinning triggers landscape generation Cloud Functions).
  public get advancedSearchActionsEnabled(): boolean {
    return !this.plainSearchMode;
  }

  public get plainSearchSelectedCount(): number {
    return this.plainSearchSelectedIds.size;
  }

  // A card is saveable only with portrait + landscape + title (backend rejects
  // otherwise). portrait/landscape live on the pair URL fields after mapping.
  public isPlainSearchCardSelectable(card: AdvancedSearchPreviewCard): boolean {
    return !!card.pairPortraitImageUrl && !!card.pairLandscapeImageUrl && !!(card.title || '').trim();
  }

  public isPlainSearchCardSelected(cardId: string): boolean {
    return this.plainSearchSelectedIds.has(cardId);
  }

  public togglePlainSearchSelection(cardId: string): void {
    const card = this.advancedSearchCards.find((item) => item.id === cardId);
    if (!card || !this.isPlainSearchCardSelectable(card)) {
      return;
    }

    if (this.plainSearchSelectedIds.has(cardId)) {
      this.plainSearchSelectedIds.delete(cardId);
    } else {
      this.plainSearchSelectedIds.add(cardId);
    }
  }

  // Disabled state for the composer's Save Collection action (both flows).
  public get advancedSearchSaveActionDisabled(): boolean {
    if (this.plainSearchMode) {
      return this.advancedSearchCollectionSaveInProgress || this.plainSearchSelectedCount === 0;
    }

    return !this.hasSuccessfulAdvancedSearchCards
      || this.advancedSearchAutoPairInProgress
      || this.advancedSearchCollectionSaveInProgress;
  }

  public get shouldShowAdvancedSearchCollectionSaveAction(): boolean {
    if (this.plainSearchMode) {
      return this.plainSearchSelectedCount > 0;
    }

    const submittedPrompt = this.lastSubmittedAdvancedSearchPrompt.trim();

    return this.advancedSearchUiState === 'success'
      && this.hasSuccessfulAdvancedSearchCards
      && submittedPrompt.length > 0
      && !this.hasAdvancedSearchDraftDivergedFromSession();
  }

  public get shouldDimLibraryBackground(): boolean {
    return this.webNavService.isUserAuthenticated
      && this.weblibraryMode === LIBARY_MODE.DEFAULT
      && !this.isModelFeedShown
      && (
        this.advancedSearchDraftPrompt.trim().length > 0
        || this.lastSubmittedAdvancedSearchPrompt.trim().length > 0
        || this.isAdvancedSearchActive
      );
  }

  public get advancedSearchLibraryButtonMode(): 'add' | 'close' {
    if (
      this.isAdvancedSearchActive
      || this.advancedSearchDraftPrompt.trim().length > 0
      || this.lastSubmittedAdvancedSearchPrompt.trim().length > 0
    ) {
      return 'close';
    }

    return 'add';
  }

  public get hasContentProhibitedCards(): boolean {
    return this.advancedSearchCards.some((card) => card.errorCode === 'content_prohibited');
  }

  public get eligibleAutoPairCards(): AdvancedSearchPreviewCard[] {
    return this.orderedAdvancedSearchCards.filter((card) => this.isEligibleForAutoPair(card));
  }

  public get canStartAutoPairBatch(): boolean {
    return !this.advancedSearchAutoPairInProgress && this.eligibleAutoPairCards.length > 0;
  }

  public get autoPairProgressLabel(): string {
    return `Pair previews: ${this.advancedSearchAutoPairDone}/${this.advancedSearchAutoPairTotal}`;
  }

  public get showAutoPairFooterActions(): boolean {
    return this.advancedSearchAutoPairInProgress || this.eligibleAutoPairCards.length > 0;
  }

  public isAdvancedSearchCardPinned(cardId: string): boolean {
    return this.advancedSearchPinnedCardIds.has(cardId);
  }

  public isCardLandscapeLoading(cardId: string): boolean {
    return this.advancedSearchLandscapeLoadingCardIds.has(cardId);
  }

  public onAddClicked(event?: MouseEvent): void {
    if (this.isAdvancedSearchActive) {
      this.cancelActiveAdvancedSearchGeneration();
      this.resetAdvancedSearchState('idle');
      this.advancedSearchNavbarRef?.clearDraft();
      this.advancedSearchDraftPrompt = '';
      return;
    }

    if (this.advancedSearchDraftPrompt.trim().length > 0) {
      this.advancedSearchNavbarRef?.clearDraft();
      this.advancedSearchDraftPrompt = '';
      return;
    }

    if (!this.webNavService.isUserAuthenticated) {
      this.triggerShowAuthPopup();
      return;
    }

    this.positionLibraryAddMenuAnchor(event);
    this.libraryAddMenuTrigger?.openMenu();
  }

  private positionLibraryAddMenuAnchor(event?: MouseEvent): void {
    if (typeof window === 'undefined') {
      return;
    }

    const anchorElement = this.libraryAddMenuAnchorRef?.nativeElement;
    if (!anchorElement) {
      return;
    }

    const triggerElement = event?.currentTarget as HTMLElement | null;
    const triggerRect = triggerElement?.getBoundingClientRect();

    if (!triggerRect) {
      anchorElement.style.left = `${Math.round(window.innerWidth / 2)}px`;
      anchorElement.style.bottom = '24px';
      anchorElement.style.width = '52px';
      anchorElement.style.height = '52px';
      return;
    }

    anchorElement.style.left = `${Math.round(triggerRect.left)}px`;
    anchorElement.style.bottom = `${Math.max(0, Math.round(window.innerHeight - triggerRect.bottom))}px`;
    anchorElement.style.width = `${Math.max(1, Math.round(triggerRect.width))}px`;
    anchorElement.style.height = `${Math.max(1, Math.round(triggerRect.height))}px`;
  }

  public onAddMenuAction(action: INavpanelAction): void {
    if (!this.webNavService.isUserAuthenticated) {
      this.triggerShowAuthPopup();
      return;
    }

    switch (true) {
      case action.actionType === NAVPANEL_ACTION_TYPE.NEW_COLLECTION:
        this.openNewCollectionDialog();
        break;
      case action.actionType === NAVPANEL_ACTION_TYPE.UPLOAD_MODEL:
        this.openUploadModelFlow();
        break;
      default:
        break;
    }
  }

  public onAccountClicked(): void {
    if (this.firebaseAuth.currentUser) {
      this.openAccountPopup();
      return;
    }

    this.triggerShowAuthPopup();
  }

  public onAdvancedSearchDevClicked(): void {
    if (!this.firebaseAuth.currentUser) {
      this.triggerShowAuthPopup();
      return;
    }

    this.openAdvancedSearchDevPopup();
  }

  // On a fresh page load Firebase restores the session after the first render, and until then
  // isUserAuthenticated is false — submitting right away would show a signed-in user the guest
  // gate. The uid hint in localStorage says a session is being restored, so wait for it.
  private runHandedOverSearch(query: string): void {
    const sessionPending = !this.firebaseAuth.currentUser && !!this.settingService.getOriginalUidFromLocalstorage();
    const authResolved: Observable<void> = sessionPending
      ? merge(this.firebaseAuth.firebaseUser, this.firebaseAuth.notLoggedUserSubscription).pipe(take(1), map(() => undefined))
      : of(undefined);

    this.handedOverSearchSub?.unsubscribe();
    this.handedOverSearchSub = authResolved.subscribe(() => {
      this.advancedSearchNavbarRef?.setPrompt(query);
      this.onComposerSubmit({ prompt: query, attachments: [] });
    });
  }

  public onComposerSubmit(draft: AdvancedSearchDraft): void {
    if (!this.webNavService.isUserAuthenticated) {
      this.onLibraryMainCtaClicked();
      return;
    }

    if (this.isAdvancedSearchBusy) {
      return;
    }

    const prompt = draft?.prompt?.trim() || '';
    if (!prompt) {
      this.utilityService.showSnackBar('Describe what you want to generate.', 0);
      return;
    }

    this.advancedSearchDraftPrompt = prompt;
    this.startAdvancedSearch(prompt);
  }

  public onComposerCancel(): void {
    this.cancelActiveAdvancedSearchGeneration();
    this.resetAdvancedSearchState('idle');
  }

  public onComposerDraftChanged(draft: AdvancedSearchDraft): void {
    this.advancedSearchDraftPrompt = draft?.prompt || '';
  }

  // Composer "Save Collection" action. Plain search saves the selected results
  // via the public save-collection endpoint; the generative flow keeps its own.
  public onComposerSaveCollection(): void {
    if (this.plainSearchMode) {
      this.savePlainSearchCollection();
      return;
    }

    this.saveAsSessionCollection();
  }

  public savePlainSearchCollection(): void {
    if (this.advancedSearchCollectionSaveInProgress) {
      return;
    }

    const selectedCards = this.advancedSearchCards.filter(
      (card) => this.plainSearchSelectedIds.has(card.id) && this.isPlainSearchCardSelectable(card),
    );
    if (selectedCards.length === 0) {
      this.utilityService.showSnackBar('Select at least one model to save.', 2500);
      return;
    }

    const userId = `${this.firebaseAuth.currentUser?.uid ?? ''}`.trim();
    if (!userId) {
      this.utilityService.showSnackBar('Sign in to save a collection.', 0);
      return;
    }

    const assets: SaveCollectionAsset[] = selectedCards.map((card) => ({
      asset_id: card.id,
      title: `${card.title || ''}`.trim(),
      portrait_url: `${card.pairPortraitImageUrl || ''}`.trim(),
      landscape_url: `${card.pairLandscapeImageUrl || ''}`.trim(),
    }));
    const title = `${this.lastSubmittedAdvancedSearchPrompt || this.normalizedAdvancedSearchPrompt || ''}`.trim();

    this.advancedSearchCollectionSaveInProgress = true;
    this.aiSearchService.saveCollection({ user_id: userId, title, assets }).subscribe({
      next: () => {
        this.advancedSearchCollectionSaveInProgress = false;
        this.plainSearchSelectedIds.clear();
        // showImportantSnackBar bypasses the log-level gate that suppresses
        // showSnackBar; force=true bypasses the exact-match whitelist for this
        // dynamic text. Mirror the backend's empty-title fallback.
        const displayTitle = title || 'AI Collection';
        this.utilityService.showImportantSnackBar(`Saved to collection '${displayTitle}'`, 0, 3000, undefined, true);
      },
      error: (error) => {
        this.advancedSearchCollectionSaveInProgress = false;
        this.utilityService.showImportantErrorSnackBar(
          'Failed to save collection. Please try again.',
          0,
          7000,
          { savedCount: assets.length, title, error },
        );
      },
    });
  }

  public saveAsSessionCollection(): void {
    if (this.advancedSearchCollectionSaveInProgress) {
      return;
    }

    if (this.advancedSearchAutoPairInProgress) {
      this.utilityService.showSnackBar('Pair previews are being generated, please wait…', 2500);
      return;
    }

    if (this.eligibleAutoPairCards.length > 0) {
      this.advancedSearchSaveAfterAutoPairRequested = true;
      this.utilityService.showSnackBar('Generating pair previews first…', 2500);
      void this.startAutoPairBatch();
      return;
    }

    void this.completeAdvancedSearchSessionCollectionSave();
  }

  private async completeAdvancedSearchSessionCollectionSave(): Promise<void> {
    const collection = createAdvancedSearchSessionCollection(
      this.advancedSearchCards,
      this.lastSubmittedAdvancedSearchPrompt || this.normalizedAdvancedSearchPrompt,
      this.currentAdvancedSearchMode,
    );
    this.advancedSearchSaveAfterAutoPairRequested = false;

    if (!collection) {
      this.utilityService.showSnackBar('No generated previews to save.', 0);
      return;
    }

    this.advancedSearchCollectionSaveInProgress = true;
    this.userDataService.createUserCollection(collection);

    try {
      const backendSaveResult = await this.saveAdvancedSearchSessionToAiCollection();

      if (backendSaveResult) {
        const backendCollectionId = `${backendSaveResult.collectionId || ''}`.trim();
        const backendShareId = `${backendSaveResult.shareId || ''}`.trim();
        const currentCollectionId = `${collection.collectionId || ''}`.trim();
        const shouldReplaceLocalCollectionId = !!backendCollectionId && backendCollectionId !== currentCollectionId;

        if (shouldReplaceLocalCollectionId) {
          this.userDataService.updateUserCollectionData(
            currentCollectionId,
            backendCollectionId,
            backendShareId,
          );
          collection.collectionId = backendCollectionId;
          collection.collectionSharingId = backendShareId;
          collection.collectionCards.forEach((collectionCard) => {
            collectionCard.parentCollectionId = backendCollectionId;
          });
        } else if (backendShareId && backendShareId !== `${collection.collectionSharingId || ''}`.trim()) {
          this.userDataService.updateUserCollectionData(
            currentCollectionId,
            currentCollectionId,
            backendShareId,
          );
          collection.collectionSharingId = backendShareId;
        }

        this.utilityService.showSnackBar(
          `Saved "${collection.collectionTitle}" locally and synced available previews to backend.`,
          2500,
        );
      } else {
        this.utilityService.showSnackBar(
          `Saved "${collection.collectionTitle}" locally. Backend sync skipped because preview source URLs are unavailable.`,
          2500,
        );
      }
    } catch (error) {
      this.utilityService.showImportantErrorSnackBar(
        `Saved "${collection.collectionTitle}" locally, but backend sync failed.`,
        0,
        7000,
        {
          collectionTitle: collection.collectionTitle,
          cardsCount: collection.collectionCards.length,
          prompt: this.lastSubmittedAdvancedSearchPrompt || this.normalizedAdvancedSearchPrompt,
          error,
        },
      );
    } finally {
      this.advancedSearchCollectionSaveInProgress = false;
    }

    this.resetAdvancedSearchState('idle');
    this.advancedSearchNavbarRef?.clearDraft();
    this.advancedSearchDraftPrompt = '';
  }

  public onGeneratePairPreviewsBatchClick(): void {
    void this.startAutoPairBatch();
  }

  public onRetryFailedPairPreviewsClick(): void {
    void this.startAutoPairBatch({ failedOnly: true });
  }

  public onStopAutoPairBatchClick(): void {
    this.stopAutoPairBatch();
  }

  public onAiPreviewPinToggled(cardId: string): void {
    const card = this.advancedSearchCards.find((item) => item.id === cardId);
    const portraitDataUrl = card ? this.resolveAdvancedSearchPortraitDataUrl(card) : '';
    if (!card || card.status !== 'success' || !portraitDataUrl) {
      return;
    }

    if (this.advancedSearchPinnedCardIds.has(cardId)) {
      this.advancedSearchPinnedCardIds.delete(cardId);
      return;
    }

    this.advancedSearchPinnedCardIds.add(cardId);

    if (this.shouldGenerateLandscapeForPinnedCard(card, portraitDataUrl)) {
      this.generateLandscapeForCard(card, portraitDataUrl);
    }
  }

  public onAiPreviewDeleted(cardId: string): void {
    const cardsLengthBeforeDelete = this.advancedSearchCards.length;

    this.advancedSearchCards = this.advancedSearchCards.filter((card) => card.id !== cardId);
    this.advancedSearchPinnedCardIds.delete(cardId);
    this.advancedSearchAutoPairFailedCardIds.delete(cardId);
    this.cancelAdvancedSearchLandscapeGeneration(cardId);
    this.advancedSearchCardOrderMap.delete(cardId);
    this.activeAdvancedSearchRunCardIds.delete(cardId);

    if (cardsLengthBeforeDelete !== this.advancedSearchCards.length) {
      this.normalizeAdvancedSearchUiStateAfterCardsMutation();
    }
  }

  public onAiPreviewSelected(cardId: string): void {
    const successfulCards = this.orderedAdvancedSearchCards.filter((card) => {
      return card.status === 'success' && !!(card.thumbnailImageDataUrl || card.imageDataUrl);
    });
    const startPosition = successfulCards.findIndex((card) => card.id === cardId);
    if (startPosition < 0) {
      return;
    }

    this.webLibraryFeedModificator = this.aiGeneratedGalleryFeedModificator;
    this.modelCardsMock = successfulCards.map((card, index) => this.createAiViewerCard(card, index));
    this.cardFeedCardStartPosition = startPosition;
    this.isModelFeedShown = true;
    this.webNavService.footerMode = FOOTER_MODE.DEFAULT;
  }

  public onAiPreviewRetry(cardId: string): void {
    const cardToRetry = this.advancedSearchCards.find((card) => card.id === cardId);
    if (!cardToRetry) {
      return;
    }

    if (cardToRetry.errorCode === 'content_prohibited' || cardToRetry.errorCode === 'planning_failed') {
      return;
    }

    this.updateAdvancedSearchCard(cardId, {
      status: 'loading',
      errorMessage: undefined,
    });

    if ((cardToRetry.generationMode || this.resolveAdvancedSearchGenerationMode()) === 'custom') {
      this.advancedSearchService.generateAssetPairBatch({
        assetId: cardToRetry.id,
        title: cardToRetry.title,
        imagePrompt: cardToRetry.imagePrompt,
        normalizedPrompt: this.normalizedAdvancedSearchPrompt,
        searchMode: this.currentAdvancedSearchMode,
        imageModel: this.settingService.advancedSearchRenderingModel,
        systemPrompt: this.settingService.advancedSearchCustomSystemPrompt || undefined,
        portraitTemperature: this.settingService.advancedSearchCustomPortraitTemperature,
        landscapeTemperature: this.settingService.advancedSearchCustomLandscapeTemperature,
        fullSizeLandscapePreview: true,
      }).subscribe({
        next: (response) => this.applyGeneratedCustomPairPreview(
          response,
          this.normalizedAdvancedSearchPrompt,
          this.currentAdvancedSearchMode,
        ),
        error: (error) => {
          const errorMessage = this.handleAdvancedSearchError('retry', error, {
            assets: [cardToRetry],
            prompt: this.normalizedAdvancedSearchPrompt,
          });

          this.updateAdvancedSearchCard(cardId, {
            status: 'error',
            errorMessage,
          });

          this.advancedSearchErrorMessage = errorMessage;
        }
      });
      return;
    }

    this.advancedSearchService.generateAssetPreview({
      assetId: cardToRetry.id,
      title: cardToRetry.title,
      imagePrompt: cardToRetry.imagePrompt,
      normalizedPrompt: this.normalizedAdvancedSearchPrompt,
      searchMode: this.currentAdvancedSearchMode,
      generationMode: 'single-pro',
    }).subscribe({
      next: (response) => this.applyGeneratedPreview(
        response,
        'single-pro',
        this.normalizedAdvancedSearchPrompt,
        this.currentAdvancedSearchMode,
      ),
      error: (error) => {
        const errorMessage = this.handleAdvancedSearchError('retry', error, {
          assets: [cardToRetry],
          prompt: this.normalizedAdvancedSearchPrompt,
        });

        this.updateAdvancedSearchCard(cardId, {
          status: 'error',
          errorMessage,
        });

        this.advancedSearchErrorMessage = errorMessage;
      }
    });
  }

  public trackByAdvancedSearchCardId(index: number, card: AdvancedSearchPreviewCard): string {
    return card.id || `advanced-search-card-${index}`;
  }

  public shouldShowOpenAppCta(): boolean {
    return environment.type === 'web'
      && this.webNavService.footerMode === FOOTER_MODE.LIBRARY
      && this.webNavService.shouldShowClassicLanding()
      && typeof window !== 'undefined'
      && window.innerWidth < 768;
  }

  public onOpenAppClicked(): void {
    const mobileDevice = this.utilityService.detectMobileDevice();
    if (mobileDevice === 'ios') {
      window.location.href = environment.universalLinkBaseUrl || 'https://3dway.io';
      return;
    }

    this.dialog.open(WebpopupdialogComponent, {
      data: this.utilityService.applyPopupText(POPUP_TEXT.WEB_DIALOG_ANDROID_SUPPORT_INFO),
      restoreFocus: false,
      panelClass: 'web-landing2025-page-popup'
    });
  }

  public onLibraryMainCtaClicked(): void {
    if (this.shouldShowOpenAppCta()) {
      this.onOpenAppClicked();
      return;
    }

    this.triggerShowAuthPopup();
  }

  private async loadInReviewCollection(): Promise<void> {
    if (!this.firebaseAuth.currentUser?.isAdmin) {
      this.inReviewCollection = null;
      return;
    }

    if (this.inReviewCollectionLoading || this.inReviewCollection) return;

    this.inReviewCollectionLoading = true;
    try {
      const reviewCollection = await this.reviewCollectionsService.getReviewsCollectionByStatus(this.inReviewCollectionStatus);
      this.inReviewCollection = reviewCollection;
    } catch (error) {
      console.warn('Failed to load in-review collection', error);
    } finally {
      this.inReviewCollectionLoading = false;
    }
  }

  public onInReviewCollectionClicked(): void {
    if (!this.firebaseAuth.currentUser?.isAdmin) return;
    this.router.navigateByUrl('/in-review');
  }

  get myPendingReviewCollection(): ICardCollection | null {
    const inReviewModels = this.reviewCardsForDisplay;

    if (inReviewModels.length > 0) {
      return {
        collectionId: 'my-pending-review-virtual',
        collectionTitle: 'My Models in Review',
        collectionCards: inReviewModels,
        collectionAuthor: '',
        collectionDescription: '',
        collectionPosterMobile: inReviewModels[0]?.cardPosterMobile || '',
        collectionContentMobile: inReviewModels[0]?.cardContentMobile || '',
        collectionPosterWeb: inReviewModels[0]?.cardPosterWeb || '',
        collectionContentWeb: inReviewModels[0]?.cardContentWeb || '',
        created: new Date().toISOString(),
        updated: new Date().toISOString(),
        accessType: 'Private' as any,
      } as ICardCollection;
    }
    return null;
  }

  public onMyPendingReviewCollectionClicked(): void {
    this.router.navigateByUrl('/pending-review');
  }

  ngAfterViewInit(): void {
    this.route.queryParams.subscribe(params => {
      const rawGenerationModeParam = typeof params['generationMode'] === 'string' ?
        params['generationMode'].trim() :
        '';
      this.routeAdvancedSearchGenerationModeRaw = rawGenerationModeParam || null;
      this.routeAdvancedSearchGenerationMode = normalizeAdvancedSearchGenerationMode(rawGenerationModeParam);
      this.routeAdvancedSearchGenerationModeInvalid = !!rawGenerationModeParam && !this.routeAdvancedSearchGenerationMode;

      if (params['collectionId'] || params['modelId']) {
        // Backward compatibility for old '/library?collectionId=...' links.
        // Skip redirect if we're viewing AI previews — the modelId comes from the
        // in-app viewer tracking the visible card, not from an external deep-link.
        if (this.webLibraryFeedModificator?.isAiPreviewFeed || this.isModelFeedShown) {
          return;
        }
        this.router.navigate(['/library/edit'], {
          queryParams: params
        });
        return;
      }

      // /discover hands its search over as ?q. Consumed once (stripped from the URL) and run
      // through the composer path, so the guest gate and the busy check apply as usual.
      const handedOverQuery = typeof params['q'] === 'string' ? params['q'].trim() : '';
      if (handedOverQuery) {
        this.router.navigate([], {
          relativeTo: this.route,
          queryParams: { q: null },
          queryParamsHandling: 'merge',
          replaceUrl: true,
        });
        this.runHandedOverSearch(handedOverQuery);
        return;
      }

      const sessionId = params['session_id'];
      if (sessionId) {
        // this.utilityService.showImportantSnackBar('Stripe Payment successful', 500);
        this.router.navigate([], {
          relativeTo: this.route,
          queryParams: { session_id: null },
          queryParamsHandling: 'merge', // remove to replace all query params by provided
        });
        // HERE SHOULD BE LOGIC TO CHECK TWO TIMES IF SUBSCRIPTION STATUS CHANGED;
        let subscriptionSuccess = false;

        this.openSubscriptionDialog(true);

        setTimeout(async () => {
           const status = await this.cardService.setSubForStatusSubscription();
           if(status === SUBSCRIPTION_STATUS.SUBSCRIBER) {
            subscriptionSuccess = true;
            this.closeSubscriptionDialog();
            this.utilityService.showImportantSnackBar('Welcome to 3DWay Artist Program', 500);
           }
        }, 5000);
        setTimeout(async () => {
          if(subscriptionSuccess) return;
          const status = await this.cardService.setSubForStatusSubscription();
          if(status === SUBSCRIPTION_STATUS.SUBSCRIBER) {
            subscriptionSuccess = true;
            this.closeSubscriptionDialog();
            this.utilityService.showImportantSnackBar('Welcome to 3DWay Artist Program', 500);
          }
       }, 10000);
        setTimeout(async () => {
          if(subscriptionSuccess) return;
          const status = await this.cardService.setSubForStatusSubscription();
          this.closeSubscriptionDialog();
          if(status === SUBSCRIPTION_STATUS.SUBSCRIBER) {
            this.utilityService.showImportantSnackBar('Welcome to 3DWay Artist Program', 500);
          } else {
            this.utilityService.showImportantSnackBar('Membership status not updated. Please, contact support.', 500);
          }
        }, 15000);
      }
    });
  }


  public onPublishReviewRejectGalleryClicked(): void {
    console.log('see all clicked');
    this.webNavService.currentWebSwitchPanelMode = SWITCH_PANEL_ITEM.PUBLISHED
    this.webNavService.footerMode = FOOTER_MODE.LIBRARY_PUBLISH_REJECTED_REVIEW;
    this.weblibraryMode = LIBARY_MODE.PUBLISH_REJECTED_REVIEW;
  }

  public async onSavedCollectionClicked(collection: ICardCollection): Promise<void> {
    console.log('saved collection clicked');

    this.webNavService.footerMode = FOOTER_MODE.DEFAULT;

    this.webLibraryFeedModificator = { hiddenOptionsButton: environment.production };
    this.homeCollections = await this.cardService.getCollectionFeed();
    this.modelCardsMock = this.cardService.convertCollectionsToCardsFeed(this.homeCollections);
    this.cardFeedCardStartPosition = this.modelCardsMock.findIndex(thumb => thumb.cardPosterMobile === collection.collectionPosterMobile);
    this.isModelFeedShown = true;

    // this.utilityService.triggerHaptics();
    // this.collectionDetailsSource = collection;
    // this.collectionDetailsSource.showFullscreenBackgroundPreview = true;
    // this.currentLibraryFooterMode = FOOTER_MODE.LIBRARY_LIKED_COLLECTIONS_DEATAIL;
    // this.collectionEditOptions = {mode: 'liked'};
    // this.filterCardMode = NAVPANEL_ACTION_TYPE.FILTER_ALL_MODELS;
    // this.isCollectionDetailsShown = true;
  }

  public onPortfolioCollectionClciked(): void {
    // this.userDataService.librarySavedScrollPosition = this.libraryPageViewRef.nativeElement.scrollTop;
    this.router.navigate(['/portfolio'], {
      relativeTo: this.route,
      queryParamsHandling: 'merge'
    });
  }

  public onPublishReviewRejectModelsCardClicked(card: ICard): void {
    const reviewFeedCards = this.weblibraryMode === LIBARY_MODE.PUBLISH_REJECTED_REVIEW
      && this.webNavService.currentWebSwitchPanelMode === SWITCH_PANEL_ITEM.REJECTED
      ? this.userDataService.rejectedUserCards
      : this.reviewCardsForDisplay;

    this.modelCardsMock = reviewFeedCards as ModelCardRendered[];
    this.cardFeedCardStartPosition = this.modelCardsMock.findIndex(thumb => thumb.cardPosterMobile === card.cardPosterMobile);

    this.webNavService.footerMode = FOOTER_MODE.DEFAULT;
    this.isModelFeedShown = true;

    console.log('publish review reject models card clicked', card);

  }

  get reviewCardsForDisplay(): ICard[] {
    return this.userDataService.reviewAndPublishedCards.filter((card) => {
      if (card?.purchaseStatus !== CARD_PURCHASE_STATUS.REJECTED) {
        return true;
      }
      return this.userDataService.isCardRejectedAndUnviewed(card);
    });
  }

  public async onDefaultCollectionOrganizeBtnClick(btnName: string): Promise<void> {
    // if(btnName === 'Organize') {
    //   this.currentLibraryFooterMode = FOOTER_MODE.LIBRARY_SELECT_MODELS_DISABLED;
    //   this.userDataService.allUserCards.forEach(card => card.isSelected = false);
    //   this.cardSelectData = this.userDataService.allUserCards;
    //   this.isCardPriceShown = false;
    //   this.isCardSelectShown = true;
    //   setTimeout(() => {
    //     this.cardSelectRef.showSwitchPanel();
    //     this.cardSelectRef.setSwitchPanelItem(SWITCH_PANEL_ITEM.ALL);
    //     }, 200);
    // }
  }

  public onDraftCollectionClicked(collection: ICardCollection): void {
    console.log(collection)
    // this.userDataService.librarySavedScrollPosition = this.libraryPageViewRef.nativeElement.scrollTop;
    this.router.navigate(['/library/edit'], {
      relativeTo: this.route,
      queryParams: { collectionId: collection.collectionId },
      queryParamsHandling: 'merge'
    });
  }

  public onModelCardPressed() {
    this.currentLibraryFooterMode = FOOTER_MODE.CARD_FULLSCREEN;
  }

  public onModelCardClicked(card: ModelCardRendered) {
    this.currentLibraryFooterMode = this.currentLibraryFooterMode === FOOTER_MODE.DEFAULT || this.currentLibraryFooterMode === FOOTER_MODE.SHOW_BUY_BTN ? FOOTER_MODE.CARD_FULLSCREEN : FOOTER_MODE.DEFAULT;
  }


  public onCardControlBtnClicked(action: ICardAction): void {
    this.utilityService.triggerHaptics();
    this.webLibraryFeedModificator = undefined;
    this.cardToEdit = action.card;
    console.log('card clicked', action);

    switch (action.controlAction) {
      case CARD_CONTROL_BTN.CONTROL_ACTIONS_DEFAULT:
        this.utilityService.notImplemented();

        break;
      case CARD_CONTROL_BTN.UNLIKE_DRAFT_CARD:
      case CARD_CONTROL_BTN.LIKE_DRAFT_CARD:
        this.modelCardsFeedRef.dispatchCurrentCardLikeClick();
        break;
      case CARD_CONTROL_BTN.CANCEL_PUBLISH:
        this.openCancelPublishingCardConfirmationDialog(this.cardToEdit)
        break;
      case CARD_CONTROL_BTN.RENAME_CARD:
        // TO BE DONE !

        // this.nameDialogDefaultValue = this.cardToEdit.cardTitle;
        // this.lastNameInputValue = this.cardToEdit.cardTitle;
        // this.webNavService.footerMode = FOOTER_MODE.RENAME_ITEM;
        // this.isNameChangeDialogueShown = true;
        break;
      case CARD_CONTROL_BTN.DELETE_MODEL:
        // TO BE DONE !
        this.utilityService.notImplemented();

        break;
      case CARD_CONTROL_BTN.CONTROL_ACTION_REJECTED:
        this.openRejectedStatusDialog();
        break;
      case CARD_CONTROL_BTN.PUBLISH_SINGLE_CARD:
        console.log('PUBLISH SINGLE CARD', action);
        const selectedCardsToPublish = this.userDataService.uploadedCards.find(card => card.id === action.card.id);
        this.userDataService.sendModelForReview(selectedCardsToPublish);
        this.webNavService.footerMode = FOOTER_MODE.PORTFOLIO;
        this.isModelFeedShown = false;

        break;
      case CARD_CONTROL_BTN.BUY_MODEL:
        this.utilityService.notImplemented();
        break;
      case CARD_CONTROL_BTN.CONTROL_BACK_BTN:
        this.utilityService.triggerHaptics();
        console.log('Portfolio, onModelFeedBackBtnClick: ');

        if (this.webLibraryFeedModificator?.isAiPreviewFeed) {
          this.webLibraryFeedModificator = undefined;
          this.isModelFeedShown = false;
          this.webNavService.footerMode = FOOTER_MODE.LIBRARY;
          return;
        }

        switch (true) {
          case this.weblibraryMode === LIBARY_MODE.PUBLISH_REJECTED_REVIEW:
            this.webNavService.footerMode = FOOTER_MODE.LIBRARY_PUBLISH_REJECTED_REVIEW;
            this.isModelFeedShown = false;
            break;
          default:
            // this.onPortfolioSwitchPanelClick(this.currentPortfolioSwitchPanelMode);
            this.isModelFeedShown = false;
            this.webNavService.footerMode = FOOTER_MODE.LIBRARY;
            break;
        }
        break;
      default:
        break;
    }
  }

  public openCancelPublishingCardConfirmationDialog(card: ICard) {
    const dialogConfig: MatDialogConfig<DialogData> = {

      data: this.utilityService.applyPopupText(POPUP_TEXT.CANCEL_PUBLISHING, '{modelTitle}', card.cardTitle)
    };
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      if (result === true) {
        this.cardService.cancelReviewModelPostRequest(card).then((resp) => {
          this.utilityService.showSnackBar('Review cancelled succesfully.', 500);
        }).catch(error => this.utilityService.showErrorSnackBar(`Error occured on cancelling review: ${JSON.stringify(error.error)}`, 500));

        this.userDataService.cancelModelPublishing(this.cardToEdit);
        this.webNavService.footerMode = FOOTER_MODE.LIBRARY_PUBLISH_REJECTED_REVIEW;
        this.isModelFeedShown = false;

      }
    });
  }

  private openRejectedStatusDialog(): void {
    const dialogConfig: MatDialogConfig<DialogData> = {
      data: this.utilityService.applyPopupText(POPUP_TEXT.REVIEW_STATUS_REJECTED)
    };
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(async (result) => {
      if (result !== true || !this.cardToEdit) return;
      const isMarked = await this.userDataService.markRejectedCardViewed(this.cardToEdit);
      if (!isMarked) return;

      if (this.weblibraryMode === LIBARY_MODE.PUBLISH_REJECTED_REVIEW) {
        this.isModelFeedShown = false;
        this.webNavService.footerMode = FOOTER_MODE.LIBRARY_PUBLISH_REJECTED_REVIEW;
      }
    });
  }

  private openUploadModelFlow(): void {
    if (this.webUploadService.basicCheckIfUserCanUpload()) {
      setTimeout(() => {
        this.webNavService.activateDragZoneForceShow();
      }, 170);
    }
  }

  private openNewCollectionDialog(): void {
    const dialogConfig: WebDialogData = {
      heading: 'Give your collection a name.',
      mainBtnTitle: 'Create',
      inputPlaceHolder: this.userDataService.getNewCollectionDefaultName(),
      inputValue: ''
    };

    const dialogRef = this.dialog.open(WebpopupdialogComponent, { data: dialogConfig, restoreFocus: false, panelClass: 'webpopup-overlay' });
    const sub = dialogRef.componentInstance.webpopupdialogueMainBtnClick.subscribe((collectionName: string) => {
      const collectionTitle = collectionName ? collectionName : this.userDataService.getNewCollectionDefaultName();
      const emptyCollection = this.utilityService.createEmptyCollection(collectionTitle);
      this.userDataService.createUserCollection(emptyCollection);
      this.cardService.createCollectionPostRequest(emptyCollection).then((resp) => {
        this.utilityService.showSnackBar('Collection created', 500);
        const colId = resp.collection_id;
        const shareId = resp.share_id;
        this.userDataService.updateUserCollectionData(emptyCollection.collectionId, colId, shareId);
        this.router.navigate(['/library/edit'], {
          relativeTo: this.route,
          queryParams: { collectionId: colId },
          queryParamsHandling: 'merge'
        });
      }).catch(error => this.utilityService.showErrorSnackBar(`Error occured on update: ${JSON.stringify(error.error)}`, 500));
      this.dialog.closeAll();
      sub.unsubscribe();
    });
  }

  private triggerShowAuthPopup(): void {
    this.dialog.open(AuthpopupComponent, { data: {}, restoreFocus: false, panelClass: 'webpopup-overlay' });
  }

  private openAccountPopup(): void {
    const dialogRef = this.dialog.open(WebaccountComponent, { restoreFocus: false, panelClass: ['webpopup-overlay', 'web-account'] });

    this.accountPopupSubscription?.unsubscribe();
    this.accountPopupSubscription = dialogRef.componentInstance.webAccountPopupEvent.subscribe((action) => {
      this.handleWebpanelAction(action);
    });

    dialogRef.afterClosed().subscribe(() => {
      this.accountPopupSubscription?.unsubscribe();
      this.accountPopupSubscription = undefined;
    });
  }

  private openAdvancedSearchDevPopup(): void {
    this.dialog.open(WebAdvancedSearchDevComponent, {
      restoreFocus: false,
      panelClass: ['webpopup-overlay', 'web-advanced-search-dev'],
      data: {
        routeAdvancedSearchGenerationModeOverride: this.routeAdvancedSearchGenerationMode,
        getGenerationModeValidationState: () => this.getAdvancedSearchGenerationModeValidationState(),
        resetGenerationModeToDefault: () => this.resetInvalidAdvancedSearchGenerationMode(),
        getPairBatchState: () => this.getAdvancedSearchDevPairBatchState(),
        generatePairPreviews: () => this.onGeneratePairPreviewsBatchClick(),
        retryFailedPairPreviews: () => this.onRetryFailedPairPreviewsClick(),
        stopPairBatch: () => this.onStopAutoPairBatchClick(),
        pairPreviewDebugModeChanged: () => this.applyAdvancedSearchPairPreviewDisplayModeToCards(),
        canSaveAiCollection: () => this.canSaveAdvancedSearchCustomToAiCollection(),
        saveAiCollection: () => this.saveAdvancedSearchCustomToAiCollection(),
      }
    });
  }

  private getAdvancedSearchDevPairBatchState(): WebAdvancedSearchDevPairBatchState {
    return {
      eligibleCount: this.eligibleAutoPairCards.length,
      failedCount: this.advancedSearchAutoPairFailedCardIds.size,
      total: this.advancedSearchAutoPairTotal,
      done: this.advancedSearchAutoPairDone,
      success: this.advancedSearchAutoPairSuccess,
      inProgress: this.advancedSearchAutoPairInProgress,
      stopRequested: this.advancedSearchAutoPairStopRequested,
      progressLabel: this.autoPairProgressLabel,
    };
  }

  private canSaveAdvancedSearchCustomToAiCollection(): boolean {
    if (this.isAdvancedSearchBusy || this.advancedSearchAutoPairInProgress) {
      return false;
    }

    return this.collectAdvancedSearchCustomCardsForAiCollection().length > 0;
  }

  private async saveAdvancedSearchSessionToAiCollection(): Promise<AdvancedSearchAiCollectionSaveResult | null> {
    return this.saveAdvancedSearchCardsToAiCollection(
      this.collectSuccessfulAdvancedSearchCardsForAiCollection(),
      {
        emptyStateMessage: 'No generated previews to save.',
        showSkippedAssetsMessage: false,
      },
    );
  }

  private async saveAdvancedSearchCustomToAiCollection(): Promise<AdvancedSearchAiCollectionSaveResult | null> {
    return this.saveAdvancedSearchCardsToAiCollection(
      this.collectAdvancedSearchCustomCardsForAiCollection(),
      {
        emptyStateMessage: 'No successful Custom previews to save.',
        noValidAssetsMessage: 'No valid image URLs found for Custom previews.',
        showSkippedAssetsMessage: true,
      },
    );
  }

  private collectAdvancedSearchCustomCardsForAiCollection(): AdvancedSearchPreviewCard[] {
    return this.orderedAdvancedSearchCards.filter((card) => {
      if (card.status !== 'success') {
        return false;
      }

      return card.generationMode === 'custom' || card.source === 'custom';
    });
  }

  private collectSuccessfulAdvancedSearchCardsForAiCollection(): AdvancedSearchPreviewCard[] {
    return this.orderedAdvancedSearchCards.filter((card) => card.status === 'success');
  }

  private async saveAdvancedSearchCardsToAiCollection(
    cards: AdvancedSearchPreviewCard[],
    options: AdvancedSearchAiCollectionSaveOptions,
  ): Promise<AdvancedSearchAiCollectionSaveResult | null> {
    if (cards.length === 0) {
      this.utilityService.showSnackBar(options.emptyStateMessage, 2500);
      return null;
    }

    const assets = cards
      .map((card, index) => this.buildAiCollectionInitAsset(card, index))
      .filter((asset): asset is AiCollectionInitAssetRequestDto => !!asset);

    if (assets.length === 0) {
      if (options.noValidAssetsMessage) {
        this.utilityService.showSnackBar(options.noValidAssetsMessage, 3000);
      }
      return null;
    }

    if (options.showSkippedAssetsMessage !== false && assets.length < cards.length) {
      this.utilityService.showSnackBar(
        `Skipping ${cards.length - assets.length} asset(s) without valid image URLs.`,
        3000,
      );
    }

    console.log('[AdvancedSearch] initAiCollectionPostRequest payload', {
      assetsCount: assets.length,
      gsPathsCount: assets.filter((asset) => asset.original_url_app.startsWith('gs://') && asset.original_url_web.startsWith('gs://')).length,
      sampleAssets: assets.slice(0, 3),
    });

    const response = await this.cardService.initAiCollectionPostRequest({
      title: this.buildAiCollectionTitleFromPrompt(),
      assets,
    });
    console.log('[AdvancedSearch] initAiCollectionPostRequest response', response);

    return {
      collectionId: `${response?.collection_id || ''}`,
      shareId: `${response?.share_id || response?.shareId || ''}`.trim(),
      savedCount: Array.isArray(response?.assets) ? response.assets.length : assets.length,
    };
  }

  private buildAiCollectionInitAsset(
    card: AdvancedSearchPreviewCard,
    position: number,
  ): AiCollectionInitAssetRequestDto | null {
    const originalUrlApp = this.resolveAiCollectionImageSource(card, 'portrait');
    const originalUrlWeb = this.resolveAiCollectionImageSource(card, 'landscape');

    if (!originalUrlApp || !originalUrlWeb) {
      return null;
    }

    return {
      asset_id: card.id,
      title: `${card.title || card.id || `Asset ${position + 1}`}`.trim(),
      position,
      original_url_web: originalUrlWeb,
      original_url_app: originalUrlApp,
    };
  }

  private resolveAiCollectionImageSource(
    card: AdvancedSearchPreviewCard,
    variant: 'portrait' | 'landscape',
  ): string {
    const storage = card.pairMeta?.storage;
    const storageImage = variant === 'portrait'
      ? storage?.images?.portrait
      : storage?.images?.landscape;

    const normalizedBucket = `${storage?.bucket || ''}`.trim();

    const storageGsUrl = this.buildGsStorageUrl(normalizedBucket, storageImage?.storagePath);
    if (storageGsUrl) {
      return storageGsUrl;
    }

    const remoteUrlCandidates = variant === 'portrait'
      ? [storageImage?.url, card.pairPortraitImageUrl]
      : [storageImage?.url, card.pairLandscapeImageUrl, card.viewerImageUrl];
    const remoteUrl = remoteUrlCandidates.find((value) => {
      return typeof value === 'string' && /^https?:\/\//i.test(value.trim());
    });

    return (remoteUrl || '').trim();
  }

  private buildGsStorageUrl(bucket: string | undefined, storagePath: string | undefined): string {
    const normalizedBucket = `${bucket || ''}`.trim();
    const normalizedPath = `${storagePath || ''}`.trim().replace(/^\/+/, '');
    if (!normalizedBucket || !normalizedPath) {
      return '';
    }

    return `gs://${normalizedBucket}/${normalizedPath}`;
  }

  private buildAiCollectionTitleFromPrompt(): string {
    const titleSource = this.lastSubmittedAdvancedSearchPrompt
      || this.normalizedAdvancedSearchPrompt
      || this.advancedSearchDraftPrompt
      || 'AI Collection';
    const normalizedTitle = `${titleSource}`.replace(/\s+/g, ' ').trim();

    if (!normalizedTitle) {
      return 'AI Collection';
    }

    return normalizedTitle.slice(0, 120).trim();
  }

  private handleWebpanelAction(action: INavpanelAction): void {
    switch (true) {
      case action.actionType === NAVPANEL_ACTION_TYPE.SHOW_SUBSCRIBE:
        this.openSubscriptionDialog();
        break;
      case action.actionType === NAVPANEL_ACTION_TYPE.STRIPE_HOSTED_CHECKOUT:
        this.stripeHostedCheckoutRequest();
        break;
      case action.actionType === NAVPANEL_ACTION_TYPE.FREE_TRIAL_ACTIVATION:
        this.freeTrialActivation();
        break;
      case action.actionType === NAVPANEL_ACTION_TYPE.SETTINGS:
        this.router.navigateByUrl('/service');
        break;
      case action.actionType === NAVPANEL_ACTION_TYPE.SIGN_OUT:
        this.webNavService.signOut();
        break;
      default:
        break;
    }
  }

  private openSubscriptionDialog(disabled: boolean = false): void {
    const dialogRef = this.dialog.open(WebsubscriptionComponent, {
      data: disabled,
      restoreFocus: false,
      panelClass: 'compact-webpopup-overlay',
      backdropClass: 'compact-webpopup-backdrop'
    });

    this.subscriptionPopupSubscription?.unsubscribe();
    this.subscriptionPopupSubscription = dialogRef.componentInstance.websubscriptionclicked.subscribe((action) => {
      this.handleWebpanelAction(action);
    });

    dialogRef.afterClosed().subscribe(() => {
      this.subscriptionPopupSubscription?.unsubscribe();
      this.subscriptionPopupSubscription = undefined;
    });
  }

  private closeSubscriptionDialog(): void {
    this.dialog.closeAll();
  }

  private stripeHostedCheckoutRequest(): void {
    if (!this.firebaseAuth.currentUser?.uid) {
      this.triggerShowAuthPopup();
      return;
    }

    this.cardService.createCheckOutSession().then((res: any) => {
      this.stripeService.redirectToCheckout({ sessionId: res.sessionId }).subscribe((result) => {
        if (result.error) {
          alert(result.error.message);
        }
      });
    }).catch((error) => {
      this.utilityService.showImportantErrorSnackBar(`Error occured on join membership process: ${JSON.stringify(error.error)}`, 500);
      this.dialog.closeAll();
    });
  }

  private freeTrialActivation(): void {
    this.cardService.activateTrialPostRequest().then(() => {
      if (this.firebaseAuth.currentUser) {
        this.firebaseAuth.currentUser.subscriptionStatus = SUBSCRIPTION_STATUS.TRIAL;
      }

      this.utilityService.showSnackBar('Free Trial Activated', 350);
    }).catch((error) => {
      this.utilityService.showImportantErrorSnackBar(`Error occured on free trial activation: ${JSON.stringify(error.error)}`, 500);
    });
  }

  private startAdvancedSearch(prompt: string): void {
    if (this.plainSearchMode) {
      this.startPlainSearch(prompt);
      return;
    }

    const generationModeValidationState = this.getAdvancedSearchGenerationModeValidationState();
    if (!generationModeValidationState.isValid) {
      this.utilityService.showSnackBar(
        `Invalid generation mode "${generationModeValidationState.rawMode || 'unknown'}". Reset to Economy Plus in Dev settings.`,
        4000,
      );
      return;
    }

    this.lastSubmittedAdvancedSearchPrompt = prompt.trim();
    this.cancelActiveAdvancedSearchGeneration();
    this.advancedSearchUiState = 'planning';
    this.advancedSearchErrorMessage = '';
    this.webLibraryFeedModificator = undefined;
    this.isModelFeedShown = false;
    this.webNavService.footerMode = FOOTER_MODE.LIBRARY;

    const generationMode = this.resolveAdvancedSearchGenerationMode();
    const plannerModel = generationMode === 'custom' ? this.settingService.advancedSearchPlannerModel : undefined;
    const requestToken = ++this.advancedSearchRequestToken;
    const plannerCountConfig = this.getAdvancedSearchPlannerCountConfig(generationMode);
    const planningSeedCards = this.createPlanningSeedCards(requestToken, plannerCountConfig.baselineCount);
    this.appendPlanningSeedCards(planningSeedCards);

    this.planningSubscription?.unsubscribe();
    this.planningSubscription = this.advancedSearchService
      .planAssets(
        prompt,
        plannerCountConfig.baselineCount,
        plannerCountConfig.maxCount,
        generationMode,
        plannerModel,
      )
      .subscribe({
        next: (plannerResponse) => {
          if (!this.isAdvancedSearchTokenActive(requestToken)) {
            return;
          }

          this.currentAdvancedSearchMode = plannerResponse.searchMode;
          this.normalizedAdvancedSearchPrompt = plannerResponse.normalizedPrompt;

          if (generationMode === 'custom' && plannerResponse.plannerMeta?.fallbackApplied) {
            this.utilityService.showSnackBar(
              `Planner ${plannerResponse.plannerMeta.requestedModel === 'pro' ? 'Pro' : 'Flash'} fallback applied: using ${plannerResponse.plannerMeta.usedModelId}.`,
              4500,
            );
          }

          if (
            generationMode === 'custom' &&
            plannerResponse.assets.length < plannerCountConfig.baselineCount
          ) {
            this.utilityService.showSnackBar(
              `Planner returned ${plannerResponse.assets.length} of ${plannerCountConfig.baselineCount} assets. Generating ${plannerResponse.assets.length}. Refine prompt for more variety.`,
              4000,
            );
          }

          const placeholderCards = this.advancedSearchService.createPlaceholderCards(plannerResponse.assets);
          this.replacePlanningSeedCardsWithPlannerCards(placeholderCards);
          this.advancedSearchUiState = 'generating';
          this.startPreviewGeneration(plannerResponse, requestToken, generationMode);
        },
        error: (error) => {
          if (!this.isAdvancedSearchTokenActive(requestToken)) {
            return;
          }

          const errorMessage = this.handleAdvancedSearchError('planning', error, {
            requestToken,
            prompt,
          });

          this.markPlanningSeedCardsAsError(errorMessage);
          this.advancedSearchUiState = 'error';
          this.advancedSearchErrorMessage = errorMessage;
        }
      });
  }

  // Plain backend search: hit POST /ai-search/search and render whatever the
  // backend returns as preview cards. No LLM planning, no image generation.
  private startPlainSearch(prompt: string): void {
    const query = prompt.trim();
    if (!query) {
      return;
    }

    this.lastSubmittedAdvancedSearchPrompt = query;
    this.cancelActiveAdvancedSearchGeneration();
    this.advancedSearchUiState = 'planning';
    this.advancedSearchErrorMessage = '';
    this.webLibraryFeedModificator = undefined;
    this.isModelFeedShown = false;
    this.webNavService.footerMode = FOOTER_MODE.LIBRARY;

    // Fresh result set for the new query.
    this.advancedSearchCards = [];
    this.advancedSearchPinnedCardIds.clear();
    this.plainSearchSelectedIds.clear();
    this.plainSearchLatencyMs = null;
    this.advancedSearchCardOrderMap.clear();
    this.advancedSearchOrderCounter = 0;
    this.currentAdvancedSearchMode = 'scene-kit';
    this.normalizedAdvancedSearchPrompt = query;

    const requestToken = ++this.advancedSearchRequestToken;
    const startedAt = performance.now();

    this.planningSubscription?.unsubscribe();
    this.planningSubscription = this.aiSearchService.search(query, this.plainSearchLimit).subscribe({
      next: (response) => {
        if (!this.isAdvancedSearchTokenActive(requestToken)) {
          return;
        }

        this.plainSearchLatencyMs = Math.round(performance.now() - startedAt);
        this.advancedSearchCards = this.mapAiSearchResultsToCards(response?.results ?? []);
        this.advancedSearchUiState = 'success';
      },
      error: (error) => {
        if (!this.isAdvancedSearchTokenActive(requestToken)) {
          return;
        }

        this.plainSearchLatencyMs = Math.round(performance.now() - startedAt);
        this.advancedSearchCards = [];
        this.advancedSearchErrorMessage = this.describePlainSearchError(error);
        this.advancedSearchUiState = 'error';
      },
    });
  }

  // Flatten search groups into the existing preview-card grid, de-duping by
  // asset_id (first occurrence wins). Cards are "success" immediately — the
  // backend already produced the images, so portrait_url/landscape_url map
  // straight onto the data-url fields the card reads.
  private mapAiSearchResultsToCards(groups: AiSearchResultGroup[]): AdvancedSearchPreviewCard[] {
    const seen = new Set<string>();
    const cards: AdvancedSearchPreviewCard[] = [];

    for (const group of groups) {
      for (const asset of group?.assets ?? []) {
        const portraitUrl = asset?.portrait_url ?? '';
        if (!portraitUrl) {
          continue; // the card needs an image to render
        }

        const assetId = asset?.asset_id ?? '';
        if (assetId) {
          if (seen.has(assetId)) {
            continue;
          }
          seen.add(assetId);
        }

        const landscapeUrl = asset?.landscape_url ?? '';
        cards.push({
          id: assetId || `ai-search-${cards.length + 1}`,
          title: asset?.title || group?.title || '',
          imagePrompt: '',
          order: cards.length,
          status: 'success',
          thumbnailImageDataUrl: portraitUrl,
          imageDataUrl: portraitUrl,
          viewerImageUrl: landscapeUrl || portraitUrl,
          // Keep the true portrait/landscape URLs for save-to-collection.
          pairPortraitImageUrl: portraitUrl,
          pairLandscapeImageUrl: landscapeUrl,
          searchMode: 'scene-kit',
        });
      }
    }

    return cards;
  }

  private describePlainSearchError(error: unknown): string {
    const e = error as { status?: number; error?: { message?: string } | string; message?: string };
    const status = e?.status ? `HTTP ${e.status}` : 'Request failed';
    let detail = '';
    if (typeof e?.error === 'string') {
      detail = e.error;
    } else if (e?.error && typeof e.error === 'object' && e.error.message) {
      detail = e.error.message;
    } else if (e?.message) {
      detail = e.message;
    }
    return detail ? `${status}: ${detail}` : status;
  }

  private createPlanningSeedCards(requestToken: number, count: number): AdvancedSearchPreviewCard[] {
    return Array.from({ length: count }, (_, index) => ({
      id: `planning-seed-${requestToken}-${index + 1}`,
      title: '',
      imagePrompt: '',
      order: index,
      status: 'pending',
    }));
  }

  private appendPlanningSeedCards(seedCards: AdvancedSearchPreviewCard[]): void {
    this.activePlanningSeedCardIds = new Set(seedCards.map((card) => card.id));
    this.registerAdvancedSearchCardOrder(seedCards);
    this.advancedSearchCards = [...this.advancedSearchCards, ...seedCards];
  }

  private replacePlanningSeedCardsWithPlannerCards(plannerCards: AdvancedSearchPreviewCard[]): void {
    const planningSeedIds = new Set(this.activePlanningSeedCardIds);

    this.advancedSearchCards = this.advancedSearchCards.filter((card) => !planningSeedIds.has(card.id));
    planningSeedIds.forEach((cardId) => this.advancedSearchCardOrderMap.delete(cardId));

    this.registerAdvancedSearchCardOrder(plannerCards);
    this.activeAdvancedSearchRunCardIds = new Set(plannerCards.map((card) => card.id));
    this.advancedSearchCards = [...this.advancedSearchCards, ...plannerCards];
    this.activePlanningSeedCardIds.clear();
  }

  private markPlanningSeedCardsAsError(errorMessage: string): void {
    if (this.activePlanningSeedCardIds.size === 0) {
      return;
    }

    this.activeAdvancedSearchRunCardIds.clear();

    this.advancedSearchCards = this.advancedSearchCards.map((card) => {
      if (!this.activePlanningSeedCardIds.has(card.id)) {
        return card;
      }

      return {
        ...card,
        status: 'error',
        errorCode: 'planning_failed',
        errorMessage,
      };
    });

    this.activePlanningSeedCardIds.clear();
  }

  private startPreviewGeneration(
    plannerResponse: AdvancedSearchPlannerResponse,
    requestToken: number,
    generationMode: AdvancedSearchGenerationMode,
  ): void {
    this.generationSubscription?.unsubscribe();
    if (generationMode === 'custom') {
      this.generationSubscription = this.generateCustomAssetBatch$(plannerResponse.assets, plannerResponse, requestToken).pipe(
        finalize(() => this.finalizeAdvancedSearchGeneration(requestToken)),
      ).subscribe();
      return;
    }

    const isSheetMode = generationMode === 'sheet-pro';
    if (isSheetMode) {
      if (!this.isAdvancedSearchSheetAssetCountSupported(plannerResponse.assets.length)) {
        const errorMessage = 'Sheet mode requires exactly 12 or 24 generated assets.';
        plannerResponse.assets.forEach((asset) => {
          this.updateAdvancedSearchCard(asset.id, {
            status: 'error',
            errorMessage,
          });
        });
        this.advancedSearchErrorMessage = errorMessage;
        this.advancedSearchUiState = 'error';
        return;
      }

      const sheetBatches = this.partitionAssetsForSheetGeneration(plannerResponse.assets);
      const totalBatches = sheetBatches.length;
      this.generationSubscription = from(sheetBatches).pipe(
        concatMap(
          (assetsBatch, batchIndex) => this.generateSheetBatch$(
            assetsBatch,
            plannerResponse,
            generationMode,
            requestToken,
            batchIndex + 1,
            totalBatches,
          ),
        ),
        finalize(() => this.finalizeAdvancedSearchGeneration(requestToken)),
      ).subscribe();
      return;
    }

    this.generationSubscription = this.generateSingleAssetBatch$(plannerResponse.assets, plannerResponse, requestToken).pipe(
      finalize(() => this.finalizeAdvancedSearchGeneration(requestToken)),
    ).subscribe();
  }

  private resolveAdvancedSearchGenerationMode(): AdvancedSearchGenerationMode {
    return this.routeAdvancedSearchGenerationMode || this.settingService.advancedSearchGenerationMode;
  }

  private getAdvancedSearchGenerationModeValidationState(): {
    isValid: boolean;
    rawMode: string | null;
    source: 'route' | 'storage' | null;
  } {
    if (this.routeAdvancedSearchGenerationModeInvalid) {
      return {
        isValid: false,
        rawMode: this.routeAdvancedSearchGenerationModeRaw,
        source: 'route',
      };
    }

    const storageModeValidation = this.settingService.getAdvancedSearchGenerationModeValidationState();
    if (!storageModeValidation.isValid) {
      return {
        isValid: false,
        rawMode: storageModeValidation.rawMode,
        source: 'storage',
      };
    }

    return {
      isValid: true,
      rawMode: null,
      source: null,
    };
  }

  private resetInvalidAdvancedSearchGenerationMode(): void {
    this.settingService.advancedSearchGenerationMode = ADVANCED_SEARCH_DEFAULT_GENERATION_MODE;

    if (this.routeAdvancedSearchGenerationModeInvalid) {
      this.routeAdvancedSearchGenerationMode = null;
      this.routeAdvancedSearchGenerationModeRaw = null;
      this.routeAdvancedSearchGenerationModeInvalid = false;

      void this.router.navigate([], {
        relativeTo: this.route,
        queryParams: { generationMode: null },
        queryParamsHandling: 'merge',
      });
    }

    this.utilityService.showSnackBar('Advanced Search mode reset to Economy Plus.', 2500);
  }

  private getAdvancedSearchPlannerCountConfig(generationMode: AdvancedSearchGenerationMode): {
    baselineCount: number;
    maxCount: number;
  } {
    if (generationMode === 'custom') {
      const customCount = this.settingService.advancedSearchCustomAssetCount;
      return {
        baselineCount: customCount,
        maxCount: customCount,
      };
    }

    return {
      baselineCount: this.advancedSearchBaselineCount,
      maxCount: this.advancedSearchMaxCount,
    };
  }

  private partitionAssetsForSheetGeneration(assets: AdvancedSearchPlannerAsset[]): AdvancedSearchPlannerAsset[][] {
    const sheetBatches: AdvancedSearchPlannerAsset[][] = [];

    for (let index = 0; index < assets.length; index += this.advancedSearchSheetBatchSize) {
      sheetBatches.push(assets.slice(index, index + this.advancedSearchSheetBatchSize));
    }

    return sheetBatches;
  }

  private isAdvancedSearchSheetAssetCountSupported(assetCount: number): boolean {
    return assetCount >= this.advancedSearchSheetBatchSize && assetCount % this.advancedSearchSheetBatchSize === 0;
  }

  private generateSheetBatch$(
    assetsBatch: AdvancedSearchPlannerAsset[],
    plannerResponse: AdvancedSearchPlannerResponse,
    generationMode: AdvancedSearchGenerationMode,
    requestToken: number,
    batchNumber: number,
    totalBatches: number,
  ): Observable<GenerateAdvancedSearchAssetSheetResponse | null> {
    assetsBatch.forEach((asset) => {
      this.updateAdvancedSearchCard(asset.id, {
        status: 'loading',
        errorMessage: undefined,
      });
    });

    return timer(batchNumber === 1 ? 0 : this.advancedSearchSheetBatchDelayMs).pipe(
      concatMap(() => {
        const requestPayload = {
          normalizedPrompt: plannerResponse.normalizedPrompt,
          searchMode: plannerResponse.searchMode,
          assets: assetsBatch.map((asset) => ({
            assetId: asset.id,
            title: asset.title,
            imagePrompt: asset.imagePrompt,
          })),
        };

        return this.advancedSearchService.generateAssetSheetPro(requestPayload);
      }),
      retry({
        count: this.advancedSearchSheetBatchRetryCount,
        delay: (error, retryAttempt) => {
          if (!this.isRetriableAdvancedSearchSheetError(error)) {
            throw error;
          }

          const retryDelayMs = this.advancedSearchSheetBatchRetryDelayMs * retryAttempt;
          return timer(retryDelayMs);
        },
      }),
      tap((response) => {
        if (!this.isAdvancedSearchTokenActive(requestToken)) {
          return;
        }

        this.applyGeneratedPreviews(
          response.results,
          generationMode,
          plannerResponse.normalizedPrompt,
          plannerResponse.searchMode,
        );
      }),
      catchError((error) => {
        if (!this.isAdvancedSearchTokenActive(requestToken)) {
          return of(null);
        }

        const isProhibited = this.isContentProhibitedError(error);

        if (isProhibited) {
          const prohibitedMessage = 'This search topic can\'t be previewed due to content restrictions. Please rephrase your search.';

          assetsBatch.forEach((asset) => {
            this.updateAdvancedSearchCard(asset.id, {
              status: 'error',
              errorCode: 'content_prohibited',
              errorMessage: prohibitedMessage,
            });
          });

          this.advancedSearchErrorMessage = prohibitedMessage;
          this.advancedSearchUiState = 'error';
          return of(null);
        }

        const errorMessage = this.handleAdvancedSearchError('sheet-batch', error, {
          assets: assetsBatch,
          batchNumber,
          totalBatches,
          requestToken,
          prompt: plannerResponse.normalizedPrompt,
        });

        assetsBatch.forEach((asset) => {
          this.updateAdvancedSearchCard(asset.id, {
            status: 'error',
            errorMessage,
          });
        });

        if (!this.advancedSearchErrorMessage) {
          this.advancedSearchErrorMessage = errorMessage;
        }

        return of(null);
      }),
    );
  }

  private getSheetGenerationModeLabel(mode: AdvancedSearchGenerationMode): string {
    return getAdvancedSearchGenerationModeLabel(mode);
  }

  private getCurrentSheetGenerationModeLabel(): string {
    return this.getSheetGenerationModeLabel(this.resolveAdvancedSearchGenerationMode());
  }

  private resolveAdvancedSearchPortraitDataUrl(card: AdvancedSearchPreviewCard): string {
    return card.thumbnailImageDataUrl || card.imageDataUrl || '';
  }

  private isEligibleForAutoPair(card: AdvancedSearchPreviewCard): boolean {
    if (!card || card.status !== 'success') {
      return false;
    }

    const cardGenerationMode = card.generationMode || this.resolveAdvancedSearchGenerationMode();
    const hasGeneratedPairBatch = !!(card.pairBatchImageUrl || card.pairBatchImageDataUrl);
    return card.source === 'sheet'
      && cardGenerationMode === 'sheet-pro'
      && !hasGeneratedPairBatch;
  }

  private collectAutoPairCandidates(options: { failedOnly: boolean }): AdvancedSearchPreviewCard[] {
    const eligibleCards = this.eligibleAutoPairCards;
    if (!options.failedOnly) {
      return eligibleCards;
    }

    return eligibleCards.filter((card) => this.advancedSearchAutoPairFailedCardIds.has(card.id));
  }

  private shouldGenerateLandscapeForPinnedCard(
    card: AdvancedSearchPreviewCard,
    portraitDataUrl: string,
  ): boolean {
    return !!portraitDataUrl && this.isEligibleForAutoPair(card);
  }

  private generateLandscapeForCard(card: AdvancedSearchPreviewCard, portraitDataUrl: string): void {
    if (!this.shouldGenerateLandscapeForPinnedCard(card, portraitDataUrl)) {
      return;
    }

    void this.runPairGenerationForCard(card, portraitDataUrl);
  }

  private runPairGenerationForCard(
    card: AdvancedSearchPreviewCard,
    portraitDataUrl: string,
  ): Promise<{ ok: boolean; cardId: string }> {
    const existingRequestPromise = this.advancedSearchLandscapeRequestPromises.get(card.id);
    if (existingRequestPromise) {
      return existingRequestPromise;
    }

    if (!portraitDataUrl) {
      return Promise.resolve({ ok: false, cardId: card.id });
    }

    this.advancedSearchLandscapeLoadingCardIds.add(card.id);

    const requestPromise = new Promise<{ ok: boolean; cardId: string }>((resolve) => {
      let settled = false;
      const settle = (ok: boolean): void => {
        if (settled) {
          return;
        }

        settled = true;
        resolve({ ok, cardId: card.id });
      };

      const subscription = this.advancedSearchService.generateAssetPairBatch({
        assetId: card.id,
        title: card.title,
        imagePrompt: card.imagePrompt,
        normalizedPrompt: card.normalizedPrompt || this.normalizedAdvancedSearchPrompt,
        searchMode: card.searchMode || this.currentAdvancedSearchMode,
        thumbnailImageDataUrl: card.thumbnailImageDataUrl || card.imageDataUrl || undefined,
        imageModel: 'flash',
      }).pipe(
        finalize(() => {
          this.advancedSearchLandscapeLoadingCardIds.delete(card.id);
          this.advancedSearchLandscapeSubscriptions.delete(card.id);
          this.advancedSearchLandscapeRequestPromises.delete(card.id);
          settle(false);
        }),
      ).subscribe({
        next: (response) => {
          const pairPatch: Partial<AdvancedSearchPreviewCard> = {
            pairBatchImageUrl: response.batchImageUrl || response.viewerImageUrl,
            pairPortraitImageUrl: response.portraitImageUrl,
            pairLandscapeImageUrl: response.landscapeImageUrl,
            pairBatchImageDataUrl: response.batchImageDataUrl,
            pairPortraitImageDataUrl: response.portraitImageDataUrl,
            pairLandscapeImageDataUrl: response.landscapeImageDataUrl || response.viewerImageDataUrl,
            pairMeta: response.pairMeta,
            promptUsed: response.promptUsed,
            viewerPromptUsed: response.viewerPromptUsed,
          };
          const cardWithPairPatch: AdvancedSearchPreviewCard = {
            ...card,
            ...pairPatch,
          };
          const pairDisplayPatch = this.buildAdvancedSearchPairPreviewDisplayPatch(cardWithPairPatch);
          const viewerImageSource = pairDisplayPatch.viewerImageUrl
            || pairDisplayPatch.viewerImageDataUrl
            || '';

          if (!viewerImageSource) {
            console.warn('[AdvancedSearch] Pair preview generation returned no image URL', {
              cardId: card.id,
              response,
            });
            settle(false);
            return;
          }

          this.updateAdvancedSearchCard(response.assetId, {
            ...pairPatch,
            ...pairDisplayPatch,
          });
          this.updateOpenAiViewerLandscapeCard(
            response.assetId,
            viewerImageSource,
            response.viewerPromptUsed,
          );

          settle(true);
        },
        error: (error) => {
          console.warn('[AdvancedSearch] Pair preview generation failed', {
            cardId: card.id,
            title: card.title,
            portraitDataUrlLength: portraitDataUrl.length,
            error,
          });
          settle(false);
        },
      });

      this.advancedSearchLandscapeSubscriptions.set(card.id, subscription);
    });

    this.advancedSearchLandscapeRequestPromises.set(card.id, requestPromise);
    return requestPromise;
  }

  private async startAutoPairBatch(options: { failedOnly?: boolean } = {}): Promise<void> {
    if (this.advancedSearchAutoPairInProgress) {
      return;
    }

    const failedOnly = !!options.failedOnly;
    const candidates = this.collectAutoPairCandidates({ failedOnly });
    if (!candidates.length) {
      this.utilityService.showSnackBar(
        failedOnly ? 'No failed pair previews to retry.' : 'No pair previews to generate.',
        0,
      );
      return;
    }

    if (!failedOnly) {
      this.advancedSearchAutoPairFailedCardIds.clear();
    }

    this.advancedSearchAutoPairInProgress = true;
    this.advancedSearchAutoPairStopRequested = false;
    this.advancedSearchAutoPairLastRunStopped = false;
    this.advancedSearchAutoPairTotal = candidates.length;
    this.advancedSearchAutoPairDone = 0;
    this.advancedSearchAutoPairSuccess = 0;

    try {
      for (let index = 0; index < candidates.length; index += this.advancedSearchAutoPairBatchSize) {
        if (this.advancedSearchAutoPairStopRequested) {
          this.advancedSearchAutoPairLastRunStopped = true;
          break;
        }

        const cardsWave = candidates.slice(index, index + this.advancedSearchAutoPairBatchSize);
        await this.executeAutoPairWave(cardsWave);
      }
    } finally {
      this.advancedSearchAutoPairInProgress = false;
      this.advancedSearchAutoPairStopRequested = false;
    }

    const shouldSaveCollection = this.advancedSearchSaveAfterAutoPairRequested && !this.advancedSearchAutoPairLastRunStopped;
    this.advancedSearchSaveAfterAutoPairRequested = false;

    if (shouldSaveCollection) {
      void this.completeAdvancedSearchSessionCollectionSave();
      return;
    }

    const failedCount = this.advancedSearchAutoPairFailedCardIds.size;
    if (this.advancedSearchAutoPairLastRunStopped) {
      this.utilityService.showSnackBar(`Stopped at ${this.advancedSearchAutoPairDone}/${this.advancedSearchAutoPairTotal}.`, 0);
      return;
    }

    if (failedCount > 0) {
      this.utilityService.showSnackBar(`Generated ${this.advancedSearchAutoPairSuccess}, failed ${failedCount}.`, 0);
      return;
    }

    this.utilityService.showSnackBar(`Generated pair previews for ${this.advancedSearchAutoPairSuccess} cards.`, 0);
  }

  private stopAutoPairBatch(): void {
    if (!this.advancedSearchAutoPairInProgress) {
      return;
    }

    this.advancedSearchAutoPairStopRequested = true;
  }

  private async executeAutoPairWave(cardsWave: AdvancedSearchPreviewCard[]): Promise<void> {
    const results = await Promise.all(cardsWave.map(async (card) => {
      const portraitDataUrl = this.resolveAdvancedSearchPortraitDataUrl(card);
      try {
        const result = await this.runPairGenerationForCard(card, portraitDataUrl);
        return {
          cardId: card.id,
          ok: !!result.ok,
        };
      } catch (error) {
        console.warn('[AdvancedSearch] Pair preview wave item failed unexpectedly', {
          cardId: card.id,
          error,
        });
        return {
          cardId: card.id,
          ok: false,
        };
      }
    }));

    results.forEach((result) => {
      const cardId = result.cardId || '';
      const isSuccess = !!result.ok;

      this.advancedSearchAutoPairDone += 1;
      if (isSuccess) {
        this.advancedSearchAutoPairSuccess += 1;
        this.advancedSearchAutoPairFailedCardIds.delete(cardId);
        return;
      }

      this.advancedSearchAutoPairFailedCardIds.add(cardId);
    });
  }

  private generateSingleAssetBatch$(
    assets: AdvancedSearchPlannerAsset[],
    plannerResponse: AdvancedSearchPlannerResponse,
    requestToken: number,
  ): Observable<GenerateAdvancedSearchAssetResponse | null> {
    return from(assets).pipe(
      mergeMap(
        (asset) => this.generateSingleAssetPreview$(asset, plannerResponse, requestToken),
        this.advancedSearchGenerationConcurrency,
      ),
    );
  }

  private generateSingleAssetPreview$(
    asset: AdvancedSearchPlannerAsset,
    plannerResponse: AdvancedSearchPlannerResponse,
    requestToken: number,
  ): Observable<GenerateAdvancedSearchAssetResponse | null> {
    this.updateAdvancedSearchCard(asset.id, {
      status: 'loading',
      errorMessage: undefined,
    });

    return this.advancedSearchService.generateAssetPreview({
      assetId: asset.id,
      title: asset.title,
      imagePrompt: asset.imagePrompt,
      normalizedPrompt: plannerResponse.normalizedPrompt,
      searchMode: plannerResponse.searchMode,
      generationMode: 'single-pro',
    }).pipe(
      tap((response) => {
        if (!this.isAdvancedSearchTokenActive(requestToken)) {
          return;
        }

        this.applyGeneratedPreview(
          response,
          'single-pro',
          plannerResponse.normalizedPrompt,
          plannerResponse.searchMode,
        );
      }),
      catchError((error) => {
        if (this.isAdvancedSearchTokenActive(requestToken)) {
          const errorMessage = this.handleAdvancedSearchError('single-asset', error, {
            assets: [asset],
            requestToken,
            prompt: plannerResponse.normalizedPrompt,
            notifyUser: !this.advancedSearchErrorMessage,
          });

          this.updateAdvancedSearchCard(asset.id, {
            status: 'error',
            errorMessage,
          });

          if (!this.advancedSearchErrorMessage) {
            this.advancedSearchErrorMessage = errorMessage;
          }
        }

        return of(null);
      }),
    );
  }

  private generateCustomAssetBatch$(
    assets: AdvancedSearchPlannerAsset[],
    plannerResponse: AdvancedSearchPlannerResponse,
    requestToken: number,
  ): Observable<GenerateAdvancedSearchAssetPairBatchResponse | null> {
    return from(assets).pipe(
      mergeMap(
        (asset) => this.generateCustomAssetPreview$(asset, plannerResponse, requestToken),
        this.advancedSearchGenerationConcurrency,
      ),
    );
  }

  private generateCustomAssetPreview$(
    asset: AdvancedSearchPlannerAsset,
    plannerResponse: AdvancedSearchPlannerResponse,
    requestToken: number,
  ): Observable<GenerateAdvancedSearchAssetPairBatchResponse | null> {
    this.updateAdvancedSearchCard(asset.id, {
      status: 'loading',
      errorMessage: undefined,
    });

    return this.advancedSearchService.generateAssetPairBatch({
      assetId: asset.id,
      title: asset.title,
      imagePrompt: asset.imagePrompt,
      normalizedPrompt: plannerResponse.normalizedPrompt,
      searchMode: plannerResponse.searchMode,
      imageModel: this.settingService.advancedSearchRenderingModel,
      systemPrompt: this.settingService.advancedSearchCustomSystemPrompt || undefined,
      portraitTemperature: this.settingService.advancedSearchCustomPortraitTemperature,
      landscapeTemperature: this.settingService.advancedSearchCustomLandscapeTemperature,
      fullSizeLandscapePreview: true,
    }).pipe(
      tap((response) => {
        if (!this.isAdvancedSearchTokenActive(requestToken)) {
          return;
        }

        this.applyGeneratedCustomPairPreview(
          response,
          plannerResponse.normalizedPrompt,
          plannerResponse.searchMode,
        );
      }),
      catchError((error) => {
        if (this.isAdvancedSearchTokenActive(requestToken)) {
          const errorMessage = this.handleAdvancedSearchError('single-asset', error, {
            assets: [asset],
            requestToken,
            prompt: plannerResponse.normalizedPrompt,
            notifyUser: !this.advancedSearchErrorMessage,
          });

          this.updateAdvancedSearchCard(asset.id, {
            status: 'error',
            errorMessage,
          });

          if (!this.advancedSearchErrorMessage) {
            this.advancedSearchErrorMessage = errorMessage;
          }
        }

        return of(null);
      }),
    );
  }

  private cancelAdvancedSearchLandscapeGeneration(cardId: string): void {
    this.advancedSearchLandscapeSubscriptions.get(cardId)?.unsubscribe();
    this.advancedSearchLandscapeSubscriptions.delete(cardId);
    this.advancedSearchLandscapeRequestPromises.delete(cardId);
    this.advancedSearchLandscapeLoadingCardIds.delete(cardId);
  }

  private cancelAllAdvancedSearchLandscapeGeneration(): void {
    this.advancedSearchLandscapeSubscriptions.forEach((subscription) => subscription.unsubscribe());
    this.advancedSearchLandscapeSubscriptions.clear();
    this.advancedSearchLandscapeRequestPromises.clear();
    this.advancedSearchLandscapeLoadingCardIds.clear();
  }

  private updateOpenAiViewerLandscapeCard(
    cardId: string,
    viewerImageDataUrl: string,
    viewerPromptUsed: string,
  ): void {
    if (!this.isModelFeedShown || !this.webLibraryFeedModificator?.isAiPreviewFeed) {
      return;
    }

    this.modelCardsMock = this.modelCardsMock.map((card) => {
      if (card.id !== cardId) {
        return card;
      }

      return {
        ...card,
        cardContentMobile: viewerImageDataUrl,
        cardPosterMobile: viewerImageDataUrl,
        cardContentWeb: viewerImageDataUrl,
        cardPosterWeb: viewerImageDataUrl,
        cardDescription: viewerPromptUsed || card.cardDescription,
      };
    });
  }

  private resetAdvancedSearchState(nextState: AdvancedSearchUiState = 'idle'): void {
    this.stopAutoPairBatch();
    this.advancedSearchUiState = nextState;
    this.advancedSearchCards = [];
    this.advancedSearchPinnedCardIds.clear();
    this.plainSearchSelectedIds.clear();
    this.plainSearchLatencyMs = null;
    this.cancelAllAdvancedSearchLandscapeGeneration();
    this.advancedSearchAutoPairInProgress = false;
    this.advancedSearchAutoPairStopRequested = false;
    this.advancedSearchAutoPairTotal = 0;
    this.advancedSearchAutoPairDone = 0;
    this.advancedSearchAutoPairSuccess = 0;
    this.advancedSearchAutoPairLastRunStopped = false;
    this.advancedSearchAutoPairFailedCardIds.clear();
    this.advancedSearchCardOrderMap.clear();
    this.activeAdvancedSearchRunCardIds.clear();
    this.activePlanningSeedCardIds.clear();
    this.advancedSearchOrderCounter = 0;
    this.advancedSearchSaveAfterAutoPairRequested = false;
    this.advancedSearchErrorMessage = '';
    this.normalizedAdvancedSearchPrompt = '';
    this.lastSubmittedAdvancedSearchPrompt = '';
    this.currentAdvancedSearchMode = 'scene-kit';
  }

  private cancelActiveAdvancedSearchGeneration(): void {
    this.planningSubscription?.unsubscribe();
    this.planningSubscription = undefined;
    this.generationSubscription?.unsubscribe();
    this.generationSubscription = undefined;
    this.activeAdvancedSearchRunCardIds.clear();
    this.activePlanningSeedCardIds.clear();
    this.advancedSearchRequestToken += 1;
  }

  private isAdvancedSearchTokenActive(requestToken: number): boolean {
    return requestToken === this.advancedSearchRequestToken;
  }

  private finalizeAdvancedSearchGeneration(requestToken: number): void {
    if (!this.isAdvancedSearchTokenActive(requestToken)) {
      return;
    }

    const currentRunCards = this.advancedSearchCards.filter((card) => this.activeAdvancedSearchRunCardIds.has(card.id));
    const hasSuccessfulCards = currentRunCards.some((card) => card.status === 'success');
    const hasErroredCards = currentRunCards.some((card) => card.status === 'error');

    if (currentRunCards.length === 0) {
      this.normalizeAdvancedSearchUiStateAfterCardsMutation();
      return;
    }

    if (!hasSuccessfulCards && hasErroredCards) {
      this.advancedSearchUiState = 'error';
      if (!this.advancedSearchErrorMessage) {
        this.advancedSearchErrorMessage = 'Unable to generate previews. Please try again.';
      }
      this.restoreAdvancedSearchSessionPromptIfNeeded();
      this.activeAdvancedSearchRunCardIds.clear();
      return;
    }

    this.advancedSearchUiState = 'success';
    this.restoreAdvancedSearchSessionPromptIfNeeded();
    this.activeAdvancedSearchRunCardIds.clear();
  }

  private hasAdvancedSearchDraftDivergedFromSession(): boolean {
    const draftPrompt = this.advancedSearchDraftPrompt.trim();
    const submittedPrompt = this.lastSubmittedAdvancedSearchPrompt.trim();

    if (!draftPrompt || !submittedPrompt) {
      return false;
    }

    return draftPrompt !== submittedPrompt;
  }

  private restoreAdvancedSearchSessionPromptIfNeeded(): void {
    const submittedPrompt = this.lastSubmittedAdvancedSearchPrompt.trim();
    const draftPrompt = this.advancedSearchDraftPrompt.trim();

    if (!submittedPrompt || draftPrompt.length > 0) {
      return;
    }

    this.advancedSearchDraftPrompt = this.lastSubmittedAdvancedSearchPrompt;
    this.advancedSearchNavbarRef?.setPrompt(this.lastSubmittedAdvancedSearchPrompt);
  }

  private updateAdvancedSearchCard(cardId: string, patch: Partial<AdvancedSearchPreviewCard>): void {
    this.advancedSearchCards = this.advancedSearchCards.map((card) => {
      if (card.id !== cardId) {
        return card;
      }

      return {
        ...card,
        ...patch,
      };
    });
  }

  private hasAdvancedSearchPairPreviewData(card: AdvancedSearchPreviewCard): boolean {
    return !!(
      card.pairBatchImageUrl ||
      card.pairBatchImageDataUrl ||
      card.pairPortraitImageUrl ||
      card.pairPortraitImageDataUrl ||
      card.pairLandscapeImageUrl ||
      card.pairLandscapeImageDataUrl
    );
  }

  private resolveAdvancedSearchPairPortraitSource(card: AdvancedSearchPreviewCard): string {
    return card.pairPortraitImageUrl
      || card.pairPortraitImageDataUrl
      || card.thumbnailImageDataUrl
      || card.imageDataUrl
      || '';
  }

  private resolveAdvancedSearchPairLandscapeSource(card: AdvancedSearchPreviewCard): string {
    return card.pairLandscapeImageUrl
      || card.pairLandscapeImageDataUrl
      || card.viewerImageUrl
      || card.viewerImageDataUrl
      || card.imageDataUrl
      || '';
  }

  private resolveAdvancedSearchPairBatchSource(card: AdvancedSearchPreviewCard): string {
    return card.pairBatchImageUrl
      || card.pairBatchImageDataUrl
      || this.resolveAdvancedSearchPairLandscapeSource(card);
  }

  private buildAdvancedSearchPairPreviewDisplayPatch(card: AdvancedSearchPreviewCard): Partial<AdvancedSearchPreviewCard> {
    const portraitSource = this.resolveAdvancedSearchPairPortraitSource(card);
    const landscapeSource = this.resolveAdvancedSearchPairLandscapeSource(card);
    const batchSource = this.resolveAdvancedSearchPairBatchSource(card);
    const viewerSource = this.settingService.advancedSearchPairPreviewDebugMode
      ? batchSource || landscapeSource
      : landscapeSource || batchSource;

    const patch: Partial<AdvancedSearchPreviewCard> = {};
    if (portraitSource) {
      patch.thumbnailImageDataUrl = portraitSource;
      patch.imageDataUrl = portraitSource;
    }
    if (viewerSource) {
      patch.viewerImageUrl = viewerSource;
      patch.viewerImageDataUrl = viewerSource;
    }

    return patch;
  }

  private applyAdvancedSearchPairPreviewDisplayModeToCards(): void {
    this.advancedSearchCards = this.advancedSearchCards.map((card) => {
      if (!this.hasAdvancedSearchPairPreviewData(card)) {
        return card;
      }

      return {
        ...card,
        ...this.buildAdvancedSearchPairPreviewDisplayPatch(card),
      };
    });

    this.refreshOpenAiViewerPairDisplayCards();
  }

  private refreshOpenAiViewerPairDisplayCards(): void {
    if (!this.isModelFeedShown || !this.webLibraryFeedModificator?.isAiPreviewFeed) {
      return;
    }

    const cardMap = new Map(this.advancedSearchCards.map((card) => [card.id, card]));
    this.modelCardsMock = this.modelCardsMock.map((modelCard, index) => {
      const advancedSearchCard = cardMap.get(modelCard.id);
      if (!advancedSearchCard) {
        return modelCard;
      }

      return {
        ...modelCard,
        ...this.createAiViewerCard(advancedSearchCard, index),
      };
    });
  }

  private registerAdvancedSearchCardOrder(cards: AdvancedSearchPreviewCard[]): void {
    cards.forEach((card) => {
      if (!this.advancedSearchCardOrderMap.has(card.id)) {
        this.advancedSearchCardOrderMap.set(card.id, this.advancedSearchOrderCounter);
        this.advancedSearchOrderCounter += 1;
      }
    });
  }

  private getAdvancedSearchCardOrder(cardId: string): number {
    const existingOrder = this.advancedSearchCardOrderMap.get(cardId);
    if (typeof existingOrder === 'number') {
      return existingOrder;
    }

    const nextOrder = this.advancedSearchOrderCounter;
    this.advancedSearchCardOrderMap.set(cardId, nextOrder);
    this.advancedSearchOrderCounter += 1;
    return nextOrder;
  }

  private normalizeAdvancedSearchUiStateAfterCardsMutation(): void {
    if (this.advancedSearchCards.length === 0) {
      this.advancedSearchUiState = 'idle';
      this.advancedSearchErrorMessage = '';
      return;
    }

    const hasErroredCards = this.advancedSearchCards.some((card) => card.status === 'error');
    this.advancedSearchUiState = hasErroredCards ? 'error' : 'success';
  }

  private applyGeneratedPreview(
    response: GenerateAdvancedSearchAssetResponse,
    generationMode?: AdvancedSearchGenerationMode,
    normalizedPrompt: string = this.normalizedAdvancedSearchPrompt,
    searchMode: AdvancedSearchMode = this.currentAdvancedSearchMode,
  ): void {
    this.updateAdvancedSearchCard(response.assetId, {
      status: 'success',
      imageDataUrl: response.imageDataUrl,
      thumbnailImageDataUrl: response.thumbnailImageDataUrl,
      viewerImageDataUrl: response.viewerImageDataUrl,
      promptUsed: response.promptUsed,
      viewerPromptUsed: response.viewerPromptUsed,
      source: response.source,
      generationMode: generationMode || response.generationMode,
      normalizedPrompt,
      searchMode,
      errorMessage: undefined,
    });
  }

  private applyGeneratedPreviews(
    responses: GenerateAdvancedSearchAssetResponse[],
    generationMode?: AdvancedSearchGenerationMode,
    normalizedPrompt: string = this.normalizedAdvancedSearchPrompt,
    searchMode: AdvancedSearchMode = this.currentAdvancedSearchMode,
  ): void {
    responses.forEach((response) => this.applyGeneratedPreview(
      response,
      generationMode,
      normalizedPrompt,
      searchMode,
    ));
  }

  private applyGeneratedCustomPairPreview(
    response: GenerateAdvancedSearchAssetPairBatchResponse,
    normalizedPrompt: string,
    searchMode: AdvancedSearchMode,
  ): void {
    const pairPatch: Partial<AdvancedSearchPreviewCard> = {
      pairBatchImageUrl: response.batchImageUrl || response.viewerImageUrl,
      pairPortraitImageUrl: response.portraitImageUrl,
      pairLandscapeImageUrl: response.landscapeImageUrl,
      pairBatchImageDataUrl: response.batchImageDataUrl,
      pairPortraitImageDataUrl: response.portraitImageDataUrl,
      pairLandscapeImageDataUrl: response.landscapeImageDataUrl || response.viewerImageDataUrl,
      pairMeta: response.pairMeta,
      promptUsed: response.promptUsed,
      viewerPromptUsed: response.viewerPromptUsed,
    };
    const existingCard = this.advancedSearchCards.find((card) => card.id === response.assetId);
    const cardWithPairPatch: AdvancedSearchPreviewCard = {
      ...(existingCard || {
        id: response.assetId,
        title: '',
        imagePrompt: '',
        order: 0,
        status: 'loading',
      }),
      ...pairPatch,
    };
    const pairDisplayPatch = this.buildAdvancedSearchPairPreviewDisplayPatch(cardWithPairPatch);

    this.updateAdvancedSearchCard(response.assetId, {
      status: 'success',
      source: 'custom',
      generationMode: 'custom',
      normalizedPrompt,
      searchMode,
      errorMessage: undefined,
      ...pairPatch,
      ...pairDisplayPatch,
    });
  }

  private createAiViewerCard(card: AdvancedSearchPreviewCard, index: number): ModelCardRendered {
    const fallbackId = `ai-preview-${index + 1}`;
    const viewerImageDataUrl = card.viewerImageUrl || card.viewerImageDataUrl || card.imageDataUrl || '';

    return {
      id: card.id || fallbackId,
      cardSharingId: card.id || fallbackId,
      publicModelId: card.id || fallbackId,
      cardContentMobile: viewerImageDataUrl,
      cardPosterMobile: viewerImageDataUrl,
      cardContentWeb: viewerImageDataUrl,
      cardPosterWeb: viewerImageDataUrl,
      cardModelLink: '',
      cardType: CARD_TYPE.MODEL,
      cardCategory: ADVANCED_SEARCH_MODE_LABELS[card.searchMode || this.currentAdvancedSearchMode],
      cardAuthor: 'AI Preview',
      cardTitle: card.title,
      cardDescription: card.viewerPromptUsed || card.promptUsed || card.imagePrompt,
      cardPrice: 0,
      purchaseStatus: CARD_PURCHASE_STATUS.DRAFT_NOT_LIKED,
      modifiedDate: new Date().toISOString(),
      visible: false,
      isFullscreen: false,
      cardShortView: false,
      isVideoShown: false,
      isPosterShown: true,
      canBePlayed: true,
      posterFit: 'cover',
    };
  }

  private isRetriableAdvancedSearchSheetError(error: unknown): boolean {
    const status = typeof error === 'object' && error !== null && 'status' in error
      ? (error as { status?: unknown }).status
      : undefined;

    return typeof status === 'number'
      && (status === 0 || [408, 409, 425, 429, 500, 502, 503, 504].includes(status));
  }

  private isContentProhibitedError(error: unknown): boolean {
    if (typeof error !== 'object' || error === null) {
      return false;
    }

    const err = error as { status?: unknown; error?: { error?: { code?: unknown } } };
    return err.status === 422 && err.error?.error?.code === 'content_prohibited';
  }

  private handleAdvancedSearchError(
    phase: 'planning' | 'sheet-batch' | 'single-asset' | 'retry',
    error: unknown,
    options: {
      assets?: Pick<AdvancedSearchPlannerAsset, 'id' | 'title'>[];
      batchNumber?: number;
      totalBatches?: number;
      requestToken?: number;
      prompt?: string;
      notifyUser?: boolean;
    } = {},
  ): string {
    const errorTitle = this.getAdvancedSearchErrorTitle(phase);
    const assets = options.assets || [];
    const assetSummary = this.summarizeAdvancedSearchAssets(assets);
    const displayMessage = [errorTitle, assetSummary ? `Assets: ${assetSummary}` : undefined]
      .filter(Boolean)
      .join(' | ');
    const contextData = {
      phase,
      batchNumber: options.batchNumber,
      totalBatches: options.totalBatches,
      requestToken: options.requestToken,
      generationMode: this.resolveAdvancedSearchGenerationMode(),
      searchMode: this.currentAdvancedSearchMode,
      uiState: this.advancedSearchUiState,
      normalizedPrompt: options.prompt || this.normalizedAdvancedSearchPrompt || undefined,
      assets: assets.map((asset) => ({
        id: asset.id,
        title: asset.title,
      })),
    };

    console.error(`[AdvancedSearch] ${errorTitle}`, {
      ...contextData,
      error,
    });

    if (options.notifyUser === false) {
      return [displayMessage, this.utilityService.formatErrorForDisplay(error)]
        .filter(Boolean)
        .join(' | ');
    }

    return this.utilityService.importantError(errorTitle, error, {
      duration: phase === 'sheet-batch' ? 15000 : 12000,
      toastContext: assetSummary ? `Assets: ${assetSummary}` : undefined,
      contextData,
    });
  }

  private getAdvancedSearchErrorTitle(
    phase: 'planning' | 'sheet-batch' | 'single-asset' | 'retry',
  ): string {
    switch (phase) {
      case 'planning':
        return 'AI preview planning failed';
      case 'sheet-batch':
        return `${this.getCurrentSheetGenerationModeLabel()} render batch failed`;
      case 'single-asset':
        return 'Preview render failed';
      case 'retry':
        return 'Preview retry failed';
      default:
        return 'AI preview request failed';
    }
  }

  private summarizeAdvancedSearchAssets(assets: Pick<AdvancedSearchPlannerAsset, 'id' | 'title'>[]): string {
    const assetLabels = assets
      .map((asset) => (asset.title || asset.id || '').trim())
      .filter(Boolean);

    if (assetLabels.length === 0) {
      return '';
    }

    const preview = assetLabels.slice(0, 3).join(', ');
    return assetLabels.length > 3
      ? `${preview} +${assetLabels.length - 3} more`
      : preview;
  }

  public ngOnDestroy(): void {
    this.uploadStatusSub.unsubscribe();
    this.initilizeDataSub.unsubscribe();
    this.handedOverSearchSub?.unsubscribe();
    this.userDataUpdatedSub?.unsubscribe();
    this.planningSubscription?.unsubscribe();
    this.generationSubscription?.unsubscribe();
    this.stopAutoPairBatch();
    this.cancelAllAdvancedSearchLandscapeGeneration();
    this.accountPopupSubscription?.unsubscribe();
    this.subscriptionPopupSubscription?.unsubscribe();
  }


}
